<template>
  <div class="container">
    <el-card class="box-card" v-if="!isUserListShow">
      <el-tabs v-model="activeNameTwo" type="card" @tab-click="handleClickTwo">
        <el-tab-pane class="elTab" label="审核列表" name="first">
          <div class="tabBox" v-if="!commissionShow">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="审核通过" name="first">
                <div class="search-box"
                     style="position: relative; display: flex; flex-wrap: wrap; gap: 16px; margin-bottom: 20px; padding-right: 100px;">

                  <!-- 日期 -->
                  <div style="display: flex; align-items: center; flex: 1 1 calc(50% - 100px); min-width: 260px;">
                    <span style="width: 90px; flex-shrink: 0; font-size: 14px; color: #333;">日期：</span>
                    <el-date-picker
                        v-model="dataTime"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="flex: 1;">
                    </el-date-picker>
                  </div>

                  <!-- 成果名称 -->
                  <div style="display: flex; align-items: center; flex: 1 1 calc(50% - 100px); min-width: 260px;">
                    <span style="width: 90px; flex-shrink: 0; font-size: 14px; color: #333;">成果名称：</span>
                    <el-input
                        v-model="achievementName"
                        placeholder="请输入成果名称进行查询"
                        clearable
                        style="flex: 1;"
                    ></el-input>
                  </div>

                  <!-- 持有单位/人 -->
                  <div style="display: flex; align-items: center; flex: 1 1 calc(50% - 100px); min-width: 260px;">
                    <span style="width: 90px; flex-shrink: 0; font-size: 14px; color: #333;">持有单位/人：</span>
                    <el-input
                        v-model="holdingUnit"
                        placeholder="请输入持有单位/人进行查询"
                        clearable
                        style="flex: 1;"
                        prefix-icon="el-icon-user"
                    ></el-input>
                  </div>

                  <!-- 完成单位/人 -->
                  <div style="display: flex; align-items: center; flex: 1 1 calc(50% - 100px); min-width: 260px;">
                    <span style="width: 90px; flex-shrink: 0; font-size: 14px; color: #333;">完成单位/人：</span>
                    <el-input
                        v-model="completionUnit"
                        placeholder="请输入完成单位/人进行查询"
                        clearable
                        style="flex: 1;"
                        prefix-icon="el-icon-user"
                    ></el-input>
                  </div>

                  <!-- 按钮，绝对定位在右上角，和第一行顶部对齐 -->
                  <div style="position: absolute; right: 0; top: 0; display: flex; flex-direction: column; gap: 8px;">
                    <el-button type="primary" @click="filterByPhoneNumber(2)" style="width: 80px; margin-left: 0;">
                      查询
                    </el-button>
                    <el-button @click="resetSearch(2)" style="width: 80px; margin-left: 0;">重置</el-button>
                  </div>
                </div>


                <div class="itemBox" v-if="passReview.length>0">

                  <div style="margin-bottom: 10px; text-align: right;">
                    <el-button type="primary" @click="saveSort">保存排序</el-button>
                  </div>

                  <el-table :data="passReview" border style="width: 100%">
                    <el-table-column prop="createTime" label="提交时间" sortable align="center" width="110" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="achievementName" label="成果名称" sortable align="center" min-width="120" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="holdingUnit" label="持有单位/人" sortable align="center" min-width="110" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="completionUnit" label="完成单位/人" sortable align="center" min-width="110" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="hashValue" label="哈希值" sortable align="center" width="78">
                      <template #default="scope">
                        <span v-if="!scope.row.hashValue" class="hash-empty">—</span>
                        <el-tooltip
                            v-else
                            placement="top"
                            effect="dark"
                            :open-delay="200"
                            popper-class="hash-value-tooltip"
                        >
                          <div slot="content">{{ scope.row.hashValue }}</div>
                          <div class="hash-cell-ellipsis">{{ scope.row.hashValue }}</div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="certificateNo" label="证书编号" sortable align="center" min-width="120" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="phoneNumber" label="手机号" sortable align="center" width="120">
                    </el-table-column>
                    <el-table-column prop="userName" label="提交账号" sortable align="center" width="120" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="certificateUrl" label="证书" align="center" width="72">
                      <template #default="scope">
                        <el-link
                            type="primary"

                            target="myTab"
                            :underline="false"
                            @click="openImgShow(scope.row.certificateUrl)"
                        >
                          查看
                        </el-link>
                      </template>
                    </el-table-column>
                    <el-table-column prop="reviewerName" label="平台审核人" align="left" min-width="110">
                      <template #default="scope">
                        <span v-if="!scope.row.reviewerName" class="reviewer-name-cell">—</span>
                        <el-tooltip
                            v-else
                            effect="dark"
                            placement="top"
                            :disabled="!scope.row.reviewerName || scope.row.reviewerName.length <= 12"
                        >
                          <div slot="content">{{ scope.row.reviewerName }}</div>
                          <span class="reviewer-name-cell">{{ scope.row.reviewerName }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="reviewerComments" label="平台审核意见" align="left" min-width="140">
                      <template #default="scope">
                        <span v-if="!scope.row.reviewerComments" class="reviewer-name-cell">—</span>
                        <el-tooltip
                            v-else
                            effect="dark"
                            placement="top"
                            :disabled="!scope.row.reviewerComments || scope.row.reviewerComments.length <= 12"
                        >
                          <div slot="content">{{ scope.row.reviewerComments }}</div>
                          <span class="reviewer-name-cell">{{ scope.row.reviewerComments }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="reviewTime" label="平台审核时间" sortable align="center" width="110" show-overflow-tooltip>
                    </el-table-column>
<!--                    <el-table-column prop="reviewerIp" label="平台审核IP" align="center" width="120" show-overflow-tooltip>-->
<!--                      <template #default="scope">-->
<!--                        <span>{{ scope.row.reviewerIp || '—' }}</span>-->
<!--                      </template>-->
<!--                    </el-table-column>-->
                    <el-table-column label="审核结果" align="center" width="96">
                      <template #default="scope">
                        <span>{{ formatAuditStatus(scope.row.auditStatus) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="二级账号审核时间" sortable align="center" prop="unitReviewTime" width="128">
                      <template #default="scope">
                        <span class="unit-review-time-cell">{{ formatUnitReviewTime(scope.row) }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column prop="certificateUrl" label="资料" align="center" width="88">
                      <template #default="scope">
                        <el-button
                            type="primary"
                            size="small"
                            :loading="scope.row.downloading"
                            @click="handleDownload(scope.row)"
                        >
                          {{ scope.row.downloading ? '下载中...' : '下载' }}
                        </el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="转化详情" align="left" min-width="220">
                      <template #default="scope">
                        <div v-if="getExclusiveTransferDetail(scope.row)" class="transfer-detail-cell">
                          <div>{{ getExclusiveTransferDetail(scope.row).label }}</div>
                          <div v-if="getExclusiveTransferDetail(scope.row).time && getExclusiveTransferDetail(scope.row).time !== '—'">
                            时间：{{ getExclusiveTransferDetail(scope.row).time }}
                          </div>
                        </div>
                        <div v-else-if="getTransferDetail(scope.row)" class="transfer-detail-cell">
                          <div v-if="getTransferDetail(scope.row).pending" class="transfer-detail-pending">转让审核中</div>
                          <div>成果：{{ getTransferDetail(scope.row).achievementName }}</div>
                          <div>时间：{{ getTransferDetail(scope.row).time }}</div>
                          <div>{{ getTransferDetail(scope.row).description }}</div>
                          <div>转化类型：{{ getTransferDetail(scope.row).transferTypeLabel }}</div>
                        </div>
                        <el-link
                            v-else-if="canDisposeAchievement(scope.row)"
                            type="primary"
                            :underline="false"
                            @click="openModal(scope.row)"
                        >
                          转化
                        </el-link>
                        <span v-else>—</span>
                      </template>
                    </el-table-column>
<!--                    <el-table-column label="生成证书" align="center" width="96" fixed="right" v-if="showAdmin">-->
<!--                      <template #default="scope">-->
<!--                        <el-button-->
<!--                            type="warning"-->
<!--                            size="mini"-->
<!--                            :loading="scope.row.regeneratingCertificate"-->
<!--                            @click="handleRegenerateCertificate(scope.row)"-->
<!--                        >重新生成</el-button>-->
<!--                      </template>-->
<!--                    </el-table-column>-->
                    <el-table-column label="排序" width="96" align="center" fixed="right">
                      <template #default="scope">
                        <el-input
                            v-model="scope.row.sort"
                            type="number"
                            :min="1"
                            size="mini"
                            style="width: 72px;"
                            placeholder="序号"
                        />
                      </template>
                    </el-table-column>

                    <el-table-column label="操作" align="center" width="260" fixed="right" class-name="table-action-col">
                      <template #default="scope">
                        <div class="table-action-cell">
                          <el-button type="text" size="mini" @click="openReviewLog(scope.row)">审核记录</el-button>
                          <el-button type="primary" size="mini" class="changeClass" @click="changeCertificateDeposit(scope.row.id,0)">
                            修改
                          </el-button>
                          <el-button size="mini" type="warning" @click="handleReturn(scope.row)">退回</el-button>
                          <el-button size="mini" class="deleteClass" @click="deleteCertificateDeposit(scope.row.id,2)">删除
                          </el-button>
                        </div>
                      </template>
                    </el-table-column>

                  </el-table>
                  <el-pagination
                      @size-change="handleSizeChangeFirst"
                      @current-change="handleCurrentChangeFirst"
                      :page-sizes="[1,10, 20, 50, 100]"
                      :page-size="pageSizeFist"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="total"
                      class="pageList"/>
                </div>
                <div class="itemBox" v-else>
                  <div class="empty">
                    <img src="@/assets/img/noUser.png" alt="" class="noData"/>
                    <div class="emptyText">暂无数据</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="审核失败" name="second">
                <div class="search-box" style="margin-bottom: 20px; display: flex; align-items: center;">
                  <span style="margin-right: 10px;">提交账号：</span>
                  <el-input
                      v-model="userName"
                      placeholder="请输入手机号进行查询"
                      clearable
                      style="width: 300px; margin-right: 10px;"
                  >

                  </el-input>

                  <span style="margin-right: 10px;">成果名称：</span>
                  <el-input
                      v-model="achievementName"
                      placeholder="请输入成果名称进行查询"
                      clearable
                      style="width: 300px;"
                  ></el-input>
                  <el-button type="primary" @click="filterByPhoneNumber(1)">查询</el-button>
                  <!-- 重置按钮 -->
                  <el-button @click="resetSearch(1)" style="margin-left: 10px;">重置</el-button>
                </div>


                <div class="itemBox" v-if="underReview.length>0">

                  <el-table :data="underReview" border style="width: 100%">
                    <el-table-column prop="createTime" label="失败时间" sortable align="center">
                    </el-table-column>
                    <el-table-column prop="achievementName" label="成果名称" align="center">
                    </el-table-column>
                    <el-table-column prop="holdingUnit" label="持有单位/人" align="center">
                    </el-table-column>
                    <el-table-column prop="completionUnit" label="完成单位/人" align="center">
                    </el-table-column>
                    <el-table-column prop="phoneNumber" label="手机号" align="center">
                    </el-table-column>
                    <el-table-column prop="userName" label="提交账号" align="center">
                    </el-table-column>
                    <el-table-column prop="reviewerName" label="平台审核人" align="left" min-width="110">
                      <template #default="scope">
                        <span v-if="!scope.row.reviewerName" class="reviewer-name-cell">—</span>
                        <el-tooltip
                            v-else
                            effect="dark"
                            placement="top"
                            :disabled="!scope.row.reviewerName || scope.row.reviewerName.length <= 12"
                        >
                          <div slot="content">{{ scope.row.reviewerName }}</div>
                          <span class="reviewer-name-cell">{{ scope.row.reviewerName }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="reviewerComments" label="平台审核意见" align="left" min-width="140">
                      <template #default="scope">
                        <span v-if="!scope.row.reviewerComments" class="reviewer-name-cell">—</span>
                        <el-tooltip
                            v-else
                            effect="dark"
                            placement="top"
                            :disabled="!scope.row.reviewerComments || scope.row.reviewerComments.length <= 12"
                        >
                          <div slot="content">{{ scope.row.reviewerComments }}</div>
                          <span class="reviewer-name-cell">{{ scope.row.reviewerComments }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="reviewTime" label="平台审核时间" sortable align="center" width="110" show-overflow-tooltip>
                    </el-table-column>
<!--                    <el-table-column prop="reviewerIp" label="平台审核IP" align="center" width="120" show-overflow-tooltip>-->
<!--                      <template #default="scope">-->
<!--                        <span>{{ scope.row.reviewerIp || '—' }}</span>-->
<!--                      </template>-->
<!--                    </el-table-column>-->
                    <el-table-column label="审核结果" align="center" width="96">
                      <template #default="scope">
                        <span>{{ formatAuditStatus(scope.row.auditStatus) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="certificateUrl" label="资料" align="center">
                      <template #default="scope">
                        <el-button
                            type="primary"
                            size="small"
                            :loading="scope.row.downloading"
                            @click="handleDownload(scope.row)"
                        >
                          {{ scope.row.downloading ? '下载中...' : '下载' }}
                        </el-button>
                      </template>
                    </el-table-column>

                    <el-table-column label="详情" align="center" min-width="140">
                      <template #default="scope">
                        <el-link
                            type="primary"
                            :underline="false"
                            @click="evidenceById(scope.row.id)"
                        >
                          查看
                        </el-link>
                        <el-link
                            type="primary"
                            :underline="false"
                            style="margin-left: 8px;"
                            @click="openReviewLog(scope.row)"
                        >
                          审核记录
                        </el-link>
                      </template>
                    </el-table-column>

                  </el-table>
                  <el-pagination
                      @size-change="handleSizeChangeTwo"
                      @current-change="handleCurrentChangeTwo"
                      :page-sizes="[1,10, 20, 50, 100]"
                      :page-size="pageSizeTwo"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="total"
                      class="pageList"/>
                </div>
                <div class="itemBox" v-else>
                  <div class="empty">
                    <img src="@/assets/img/noUser.png" alt="" class="noData"/>
                    <div class="emptyText">暂无数据</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="审核中" name="third">
                <div class="search-box" style="margin-bottom: 20px; display: flex; align-items: center;">
                  <span style="margin-right: 10px;">提交账号：</span>
                  <el-input
                      v-model="userName"
                      placeholder="请输入手机号进行查询"
                      clearable
                      style="width: 300px; margin-right: 10px;"
                  ></el-input>
                  <span style="margin-right: 10px;">成果名称：</span>
                  <el-input
                      v-model="achievementName"
                      placeholder="请输入成果名称进行查询"
                      clearable
                      style="width: 300px;"
                  ></el-input>
                  <el-button type="primary" @click="filterByPhoneNumber(0)">查询</el-button>
                  <!-- 重置按钮 -->
                  <el-button @click="resetSearch(0)" style="margin-left: 10px;">重置</el-button>
                </div>
                <div class="itemBox" v-if="pendingReview.length">

                  <!--              {{pendingReview}}-->
                  <el-table :data="pendingReview" border style="width: 100%">
                    <el-table-column prop="createTime" label="提交时间" sortable align="center" width="110" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column prop="achievementName" label="成果名称" sortable align="center" min-width="120" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="holdingUnit" label="持有单位/人" sortable align="center" min-width="110" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="completionUnit" label="完成单位/人" sortable align="center" min-width="110" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="phoneNumber" label="手机号" sortable align="center" width="120">
                    </el-table-column>
                    <el-table-column prop="userName" label="提交账号" sortable align="center" width="120" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="certificateUrl" label="资料" align="center" width="88">
                      <template #default="scope">
                        <el-button
                            type="primary"
                            size="small"
                            :loading="scope.row.downloading"
                            @click="handleDownload(scope.row)">
                          {{ scope.row.downloading ? '下载中...' : '下载' }}
                        </el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="单位审核" align="left" min-width="220" class-name="audit-review-col" v-if="showAdmin">
                      <template #default="scope">
                        <div class="audit-review-cell">
                          <div class="audit-review-unit">
                            <el-tooltip
                                v-if="scope.row.holdingUnit"
                                effect="dark"
                                placement="top"
                                :content="scope.row.holdingUnit"
                            >
                              <span class="audit-review-unit-name">{{ scope.row.holdingUnit }}</span>
                            </el-tooltip>
                            <span v-else class="audit-review-unit-name">—</span>
                          </div>
                          <div v-if="scope.row.unitReview === 0" class="audit-review-meta">
                            <el-tag size="mini" type="info">持有方暂未审核</el-tag>
                          </div>
                          <div v-else class="audit-review-meta">
                            <el-tag size="mini" :type="scope.row.unitReview === 1 ? 'success' : 'danger'">
                              {{ scope.row.unitReview === 1 ? '持有方已通过' : '持有方已拒绝' }}
                            </el-tag>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="详情" align="center" min-width="100">
                      <template #default="scope">
                        <el-link
                            type="primary"
                            :underline="false"
                            @click="evidenceById(scope.row.id)"
                        >
                          查看
                        </el-link>
                      </template>
                    </el-table-column>
                    <el-table-column label="审核" align="center" width="112" fixed="right" v-if="showAdmin">
                      <template #default="scope">
                        <div class="button-group">
                          <button class="custom-buttonPass" @click="handleApprove(scope.row)">通过</button>
                          <button class="custom-buttonRefuse" @click="handleReject(scope.row)">拒绝</button>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column label="操作" align="center" width="132" fixed="right" class-name="table-action-col">
                      <template #default="scope">
                        <div class="table-action-cell">
                          <el-button type="primary" size="mini" class="changeClass" @click="changeCertificateDeposit(scope.row.id,0)">
                            修改
                          </el-button>
                          <el-button size="mini" class="deleteClass" @click="deleteCertificateDeposit(scope.row.id,0)">删除
                          </el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                      @size-change="handleSizeChangeThree"
                      @current-change="handleCurrentChangeThree"
                      :page-sizes="[1,10, 20, 50, 100]"
                      :page-size="pageSizeThree"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="total"
                      class="pageList"/>

                </div>


                <div class="itemBox" v-else>
                  <div class="empty">
                    <img src="@/assets/img/noUser.png" alt="" class="noData"/>
                    <div class="emptyText">暂无数据</div>
                  </div>
                </div>

              </el-tab-pane>
              <el-tab-pane label="委托评估" name="four">
                <div class="search-box" style="margin-bottom: 20px; display: flex; align-items: center;">
                  <span style="margin-right: 10px;">提交账号：</span>
                  <el-input
                      v-model="userName"
                      placeholder="请输入手机号进行查询"
                      clearable
                      style="width: 300px;"
                  >

                  </el-input>
                  <el-button type="primary" @click="con()">查询</el-button>
                  <!-- 重置按钮 -->
                  <el-button @click="conClean()" style="margin-left: 10px;">重置</el-button>
                </div>
                <div class="itemBox" v-if="commissionList.length">
                  <el-table :data="commissionList" border style="width: 100%">
                    <el-table-column prop="principalNit" label="委托人单位" align="center">
                    </el-table-column>
                    <el-table-column prop="client" label="委托人姓名" align="center">
                    </el-table-column>
                    <el-table-column prop="contactInformation" label="委托人联系电话" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="委托创建时间" align="center">
                    </el-table-column>
                    <el-table-column prop="userName" label="提交账号" align="center">
                    </el-table-column>
                    <!--          <el-table-column prop="notes" label="备注" align="center">-->
                    <!--        </el-table-column>-->
                  </el-table>
                  <el-pagination

                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :page-sizes="[1,10, 20, 50, 100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="total"
                      class="pageList"/>
                </div>
                <div class="itemBox" v-else>
                  <div class="empty">
                    <img src="@/assets/img/noUser.png" alt="" class="noData"/>
                    <div class="emptyText">暂无数据</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div v-if="commissionShow">
            <div class="returnClass" @click="goBack()">
              <img src="../assets/img/return.svg" alt="返回图标" class="icon"/>
              <span class="returnSpanClass">返回上一页</span>
            </div>
            <!-- <div id="appdiv">
            <el-button type="primary" @click="openModal">转让</el-button>
            </div> -->
            <form>
              <div class="form-row">
                <label class="form-label">成果名称:</label>
                <el-input type="text" class="form-input"
                          disabled
                          v-model="form.achievementName"/>
              </div>
            </form>
            <div class="form-row">
              <label class="form-label">持有单位/人:</label>
              <el-input type="text" class="form-input"
                        v-model="form.holdingUnit" disabled/>
            </div>
            <div class="form-row">
              <label class="form-label">完成单位/人:</label>
              <el-input type="text" class="form-input"
                        v-model="form.completionUnit" disabled/>
            </div>
            <div class="form-row">
              <label class="form-label">持有单位/人联系电话:</label>
              <el-input type="text" class="form-input" v-model="form.phoneNumber" disabled/>
            </div>
            <!--      <div class="form-row">-->
            <!--        <label class="form-label">完成单位/人联系电话:</label>-->
            <!--        <el-input type="text" class="form-input"  v-model="form.completePhoneNumber" disabled />-->
            <!--      </div>-->
            <div class="form-row">
              <label class="form-label">完成时间:</label>
              <el-date-picker class="dataclass"
                              v-model="form.completionTime"
                              type="date"
                              disabled>
              </el-date-picker>
            </div>
            <div class="rights-section">
              <label class="form-label required">技术领域:</label>
              <div class="rights-grid">
                <div class="right-optionValue" v-for="right in technicalFieldList" :key="right">
                  <input type="radio" :value="right" v-model="form.technicalField" disabled>
                  <label>{{ right }}</label>
                </div>
              </div>
            </div>
            <div class="rights-section">
              <label class="form-label">价值评估:</label>
              <div class="form-row">
                <label class="form-label">自我评估(万元):</label>
                <el-input class="form-input" v-model="form.selfValuation" disabled/>
              </div>
              <div class="form-row">
                <label class="form-label">专家评估(万元):</label>
                <el-input class="form-input" v-model="form.expertValuation" disabled/>
              </div>
              <div class="form-row">
                <label class="form-label">综合评估(万元):</label>
                <el-input class="form-input" v-model="form.comprehensiveEvaluation" disabled/>
              </div>
            </div>
            <div class="rights-section">
              <label class="form-label">转化方式:</label>
              <div class="rights-grid">
                <div class="right-option" v-for="right in rights" :key="right">
                  <input type="checkbox" :value="right" v-model="form.conversionMethod" disabled>
                  <label>{{ right }}</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <label class="form-label required">成果介绍:</label>
              <el-input type="textarea"
                        show-word-limit
                        :maxlength="100"
                        class="form-input"
                        disabled
                        v-model="form.introductionAchievements"
              />
            </div>
            <div class="form-row">
              <label class="form-label required">核心技术:</label>
              <el-input type="textarea"
                        class="form-input"
                        disabled
                        show-word-limit
                        :maxlength="100"
                        v-model="form.coreTechnology"/>
            </div>
            <div class="form-row">
              <label class="form-label required">场景应用:</label>
              <el-input type="textarea"
                        class="form-input"
                        show-word-limit
                        :maxlength="100"
                        disabled
                        v-model="form.scenarioApplication"/>
            </div>
            <div class="form-row">
              <label class="form-label required">市场前景:</label>
              <el-input type="textarea"
                        class="form-input"
                        show-word-limit
                        :maxlength="100"
                        disabled
                        v-model="form.marketProspect"/>
            </div>
            <div class="form-row">
              <div>
                <label class="form-label required">成果评价材料或其他材料（非技术）:</label>
              </div>
              <div>
                <el-link
                    v-if="form.uploadFiles"
                    type="primary"
                    :underline="false"
                    @click="openAgreementFile(form.uploadFiles)"
                >
                  {{ getEvidenceFileLabel(form.uploadFiles) }}
                </el-link>
                <span v-else>-</span>
              </div>
            </div>
            <div class="form-row">
              <label class="form-label">自我评估证明材料:</label>
              <div>
                <el-link
                    v-if="form.evaluateSupportingMaterials"
                    type="primary"
                    :underline="false"
                    @click="openAgreementFile(form.evaluateSupportingMaterials)"
                >
                  {{ getEvidenceFileLabel(form.evaluateSupportingMaterials) }}
                </el-link>
                <span v-else>-</span>
              </div>
            </div>
            <div class="form-row">
              <label class="form-label required">成果展示图片:</label>
              <div style="width:100%;text-align: center;">
                <img
                    v-if="form.uploadImg"
                    :src="getFileUrl(form.uploadImg)"
                    style="display:inline-block;text-align: center;width:20%;cursor:pointer"
                    @click="openAgreementFile(form.uploadImg)"
                />
                <span v-else>-</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane class="elTab" label="会员列表" name="two">
          <el-tabs v-model="memberListSubTab" type="card" @tab-click="handleMemberListSubTab">
            <el-tab-pane label="已注册会员" name="registered">
              <div class="search-box" style="margin-bottom: 20px; display: flex; align-items: center;">
                <div class="userNameClass">
                  <span style="margin-right: 10px;">提交账号：</span>
                  <el-input
                      v-model="userName"
                      placeholder="请输入手机号进行查询"
                      clearable
                      style="width: 300px;"
                  />
                </div>
                <div class="companyNameClass">
                  <span style="margin-right: 10px;">姓名/单位名：</span>
                  <el-input
                      v-model="companyName"
                      placeholder="请输入姓名/单位名进行查询"
                      clearable
                      style="width: 300px;"
                  />
                </div>
                <el-button type="primary" @click="queryUser()">查询</el-button>
                <el-button @click="queryUserClean()" style="margin-left: 10px;">重置</el-button>
              </div>
              <div class="itemBox" v-if="userList.length">
                <el-table :data="userList" border style="width: 100%">
                  <el-table-column prop="userName" label="手机号" align="center"/>
                  <el-table-column prop="createTime" label="创建时间" align="center"/>
                  <el-table-column prop="companyName" label="姓名/单位名" align="center"/>
                  <el-table-column prop="businessLicense" :label="userInfo.individual === 1 ? '身份证' : '营业执照'"
                                   align="center">
                    <template #default="scope">
                      <image-preview :src="scope.row.businessLicense" :width="50" :height="50"/>
                    </template>
                  </el-table-column>
                  <el-table-column label="类型" align="center">
                    <template #default="scope">
                      <span v-if="scope.row.individual === 1">个人</span>
                      <span v-else>单位</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="账号状态" align="center" width="100">
                    <template #default="scope">
                      <el-tag v-if="String(scope.row.status) === '0'" type="success">正常</el-tag>
                      <el-tag v-else type="danger">已禁用</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" min-width="180">
                    <template #default="scope">
                      <el-button type="primary" size="small" @click="resetPassword(scope.row)">
                        重置密码
                      </el-button>
                      <el-button
                          v-if="String(scope.row.status) === '0'"
                          type="danger"
                          size="small"
                          @click="toggleUserStatus(scope.row, '1')"
                      >
                        禁用
                      </el-button>
                      <el-button
                          v-else
                          type="success"
                          size="small"
                          @click="toggleUserStatus(scope.row, '0')"
                      >
                        启用
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChangeUser"
                    @current-change="handleCurrentChangeUser"
                    :page-sizes="[1,10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    class="pageList"/>
              </div>
              <div class="itemBox" v-else>
                <div class="empty">
                  <img src="@/assets/img/noUser.png" alt="" class="noData"/>
                  <div class="emptyText">暂无数据</div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="注册审核" name="registerAudit" v-if="showAdmin">
              <div class="search-box" style="margin-bottom: 20px; display: flex; align-items: center; flex-wrap: wrap; gap: 12px;">
                <div class="userNameClass">
                  <span style="margin-right: 10px;">手机号：</span>
                  <el-input
                      v-model="registerAuditQuery.username"
                      placeholder="请输入手机号"
                      clearable
                      style="width: 220px;"
                  />
                </div>
                <div class="companyNameClass">
                  <span style="margin-right: 10px;">姓名/单位名：</span>
                  <el-input
                      v-model="registerAuditQuery.companyName"
                      placeholder="请输入姓名/单位名"
                      clearable
                      style="width: 220px;"
                  />
                </div>
                <div>
                  <span style="margin-right: 10px;">审核状态：</span>
                  <el-select v-model="registerAuditQuery.auditStatus" placeholder="全部" clearable style="width: 140px;">
                    <el-option label="待审核" :value="0"/>
                    <el-option label="已拒绝" :value="1"/>
                    <el-option label="已通过" :value="2"/>
                  </el-select>
                </div>
                <el-button type="primary" @click="queryRegisterApplicationList()">查询</el-button>
                <el-button @click="resetRegisterApplicationQuery()">重置</el-button>
              </div>
              <div class="itemBox" v-if="registerApplicationList.length">
                <el-table :data="registerApplicationList" border style="width: 100%">
                  <el-table-column prop="username" label="手机号" align="center" min-width="120"/>
                  <el-table-column prop="companyName" label="姓名/单位名" align="center" min-width="120"/>
                  <el-table-column label="类型" align="center" width="80">
                    <template #default="scope">
                      <span>{{ scope.row.individual === 2 ? '单位' : '个人' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="证件照" align="center" width="90">
                    <template #default="scope">
                      <image-preview :src="scope.row.businessLicense" :width="50" :height="50"/>
                    </template>
                  </el-table-column>
                  <el-table-column prop="createTime" label="申请时间" align="center" min-width="150"/>
                  <el-table-column label="审核状态" align="center" width="100">
                    <template #default="scope">
                      <el-tag v-if="scope.row.auditStatus === 0" type="warning">待审核</el-tag>
                      <el-tag v-else-if="scope.row.auditStatus === 1" type="danger">已拒绝</el-tag>
                      <el-tag v-else-if="scope.row.auditStatus === 2" type="success">已通过</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="reviewerName" label="审核人" align="center" width="100"/>
                  <el-table-column prop="reviewTime" label="审核时间" align="center" min-width="150"/>
                  <el-table-column label="审核说明" align="center" min-width="160">
                    <template #default="scope">
                      <span v-if="scope.row.auditStatus === 1">{{ scope.row.reviewRemark || '—' }}</span>
                      <span v-else>—</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="160" fixed="right">
                    <template #default="scope">
                      <div v-if="scope.row.auditStatus === 0" class="button-group">
                        <el-button type="success" size="mini" @click="auditRegisterApplication(scope.row, 2)">通过</el-button>
                        <el-button type="danger" size="mini" @click="auditRegisterApplication(scope.row, 1)">拒绝</el-button>
                      </div>
                      <span v-else>—</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleRegisterAuditSizeChange"
                    @current-change="handleRegisterAuditCurrentChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="registerAuditPageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="registerAuditTotal"
                    class="pageList"/>
              </div>
              <div class="itemBox" v-else>
                <div class="empty">
                  <img src="@/assets/img/noUser.png" alt="" class="noData"/>
                  <div class="emptyText">暂无数据</div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <!-- 转让审核 -->
        <el-tab-pane class="elTab" label="转让审核" name="three" v-if="showAdmin">
          <div class="transfer-audit-header">
            <div class="search-box transfer-audit-search">
              <span style="margin-right: 10px;">提交账号：</span>
              <el-input
                  v-model="userName"
                  placeholder="请输入手机号进行查询"
                  clearable
                  style="width: 300px;"
              ></el-input>
              <el-button type="primary" @click="queryUserzr()">查询</el-button>
              <el-button @click="getAchievementList()">重置</el-button>
            </div>
            <el-button type="success" size="medium" icon="el-icon-plus" @click="openTransferAdd()">添加转让</el-button>
          </div>

          <div class="itemBox" v-if="achievementTransfersList.length">
            <el-table :data="achievementTransfersList" border style="width: 100%">
              <el-table-column prop="fromUserName" label="转让人" sortable align="center">
              </el-table-column>
              <el-table-column prop="holdingUnit" label="转让人单位/人" sortable align="center">
              </el-table-column>
              <el-table-column prop="achievementName" label="成果" sortable align="center">
              </el-table-column>
              <el-table-column prop="toUserName" label="接收人" sortable align="center">
              </el-table-column>
              <el-table-column prop="receiveName" label="接收单位/人" sortable align="center">
              </el-table-column>
              <el-table-column prop="receivePhone" label="联系电话" sortable align="center">
              </el-table-column>
              <el-table-column prop="uploadAgreementFile" label="转让协议" align="center" width="80">
                <template #default="scope">
                  <el-link
                      v-if="scope.row.uploadAgreementFile"
                      type="primary"
                      :underline="false"
                      @click="openAgreementFile(scope.row.uploadAgreementFile)"
                  >
                    查看
                  </el-link>
                  <span v-else>—</span>
                </template>
              </el-table-column>
              <el-table-column prop="receiveMoney" label="转让金额" sortable align="center" width="100">
              </el-table-column>
              <el-table-column prop="transferType" label="转让类型" sortable align="center" width="110">
                <template #default="scope">
                  {{ formatTransferTypeLabel(scope.row.transferType) }}
                </template>
              </el-table-column>
              <el-table-column prop="transferTime" label="转让时间" sortable align="center" width="110">
                <template #default="scope">
                  <span>{{ scope.row.transferTime || '—' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="审核状态" sortable align="center" width="100">
                <template #default="scope">
                  <span v-if="scope.row.status === 0">待审核</span>
                  <span v-else-if="scope.row.status === 1">审核失败</span>
                  <span v-else-if="scope.row.status === 2">审核成功</span>
                  <span v-else>{{ scope.row.status }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" sortable align="center">
              </el-table-column>
              <el-table-column label="操作" align="center" min-width="200">
                <template #default="scope">
                  <div class="button-group">
                    <button
                      v-if="scope.row.status === 0"
                      class="custom-buttonPass"
                      @click="handleApprove3(scope.row)"
                    >通过</button>
                    <button
                      v-if="scope.row.status === 0"
                      class="custom-buttonRefuse"
                      @click="handleReject3(scope.row)"
                    >拒绝</button>
                    <el-button
                      v-if="scope.row.status === 0"
                      type="primary"
                      size="mini"
                      plain
                      @click="openTransferEdit(scope.row)"
                    >修改</el-button>
                  </div>
                  <div v-if="scope.row.status !== 0" class="button-group">
                    <el-button
                      type="primary"
                      size="mini"
                      plain
                      @click="openTransferEdit(scope.row)"
                    >修改</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChangeUser3"
                @current-change="handleCurrentChangeUser3"
                :current-page="pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                class="pageList"/>
          </div>
          <div class="itemBox" v-else>
            <div class="empty">
              <img src="@/assets/img/noUser.png" alt="" class="noData"/>
              <div class="emptyText">暂无转让记录</div>
              <el-button type="success" icon="el-icon-plus" @click="openTransferAdd()" style="margin-top: 16px;">添加转让</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane class="elTab" label="暂存记录" name="six">

          <div class="search-box"
               style="margin-bottom: 20px; display: flex; align-items: center; flex-wrap: wrap; gap: 10px;">
            <span style="margin-right: 5px;">成果名称：</span>
            <el-input
                v-model="achievementName"
                placeholder="请输入成果名称进行查询"
                clearable
                style="width: 300px;"
            ></el-input>
            <span style="margin-left: 10px; margin-right: 5px;">排序字段：</span>
            <el-select v-model="sortField" placeholder="请选择排序字段" style="width: 150px;" clearable>
              <el-option
                  v-for="item in sortOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>


            <span style="margin-left: 10px; margin-right: 5px;">排序方向：</span>
            <el-select v-model="sortOrder" placeholder="请选择排序方向" style="width: 120px;" clearable>
              <el-option
                  v-for="item in sortOrderOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
            <!-- 查询按钮 -->
            <el-button type="primary" @click="filterByPhoneNumber(2)">查询</el-button>
            <!-- 重置按钮 -->
            <el-button @click="resetSearch(2)" style="margin-left: 10px;">重置</el-button>
          </div>
          <el-table :data="temporaryStorageList" border style="width: 100%">

            <el-table-column prop="createTime" label="提交时间" align="center">
            </el-table-column>
            <el-table-column prop="achievementName" label="成果名称" align="center">
            </el-table-column>
            <el-table-column prop="holdingUnit" label="持有单位/人" align="center">
            </el-table-column>
            <el-table-column prop="completionUnit" label="完成单位/人" align="center">
            </el-table-column>
            <el-table-column prop="phoneNumber" label="手机号" align="center">
            </el-table-column>
            <el-table-column label="详情查看" align="center">
              <template #default="scope">
                <el-link
                    type="primary"
                    target="_blank"
                    :underline="false"
                    @click="changeMessage(scope.row.id)"
                >
                  修改
                </el-link>
                <br><br>
                <div v-if="scope.row.isAchievement === 0 || scope.row.isAchievement === null">
                  <el-link
                      type="primary"
                      :underline="false"
                      @click="deleteTemporarilyById(scope.row.id)">
                    删除
                  </el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @size-change="handleSizeChangeTemporary"
              @current-change="handleCurrentTemporary"
              :page-sizes="[1,10, 20, 50, 100]"
              :page-size="pageSizeFist"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              class="pageList"/>
        </el-tab-pane>
        <el-tab-pane class="elTab" label="创建账号">
          <display/>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-card v-else>
      <div class="H2class">
        <div slot="header" class="clearfix" v-if="!commissionShow">
          <h2 @click="toExamine()">审核数据</h2>
        </div>

        <div slot="header" class="clearfixRight" v-if="!commissionShow">
          <h2>会员列表</h2>
        </div>
      </div>

    </el-card>

    <!-- 成果转让弹窗 -->
    <el-dialog
        :visible.sync="showModal"
        width="720px"
        top="6vh"
        append-to-body
        :close-on-click-modal="false"
        custom-class="transfer-dialog"
        @close="closeModal"
    >
      <div slot="title" class="transfer-dialog__header">
        <div class="transfer-dialog__header-icon">
          <i class="el-icon-s-promotion"></i>
        </div>
        <div class="transfer-dialog__header-text">
          <div class="transfer-dialog__header-title">成果转化</div>
          <div v-if="formzr.achievementName" class="transfer-dialog__header-sub">
            {{ formzr.achievementName }}
          </div>
        </div>
      </div>

      <div class="transfer-dialog__body">
        <el-form
            ref="formzrRef"
            :model="formzr"
            :rules="formRules"
            label-position="top"
            class="transfer-form"
        >
          <el-input v-model="formzr.userId" style="display: none;"/>
          <el-input v-model="formzr.userName" style="display: none;"/>
          <el-input v-model="formzr.id" style="display: none;"/>

          <section class="transfer-section">
            <div class="transfer-section__title">
              <span class="transfer-section__dot"></span>
              转化信息
            </div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="转化类型" prop="transferType">
                  <el-select
                      v-model="formzr.transferType"
                      placeholder="请选择转化类型"
                      style="width: 100%;"
                  >
                    <el-option
                        v-for="item in currentTransferTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="转化时间" prop="transferTime">
                  <el-date-picker
                      v-model="formzr.transferTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="转化金额（万元）" prop="receiveMoney">
                  <el-input v-model="formzr.receiveMoney" placeholder="请输入转化金额">
                    <template slot="prepend">¥</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="技术经理人" prop="technicalManager">
                  <el-select
                      v-model="formzr.technicalManager"
                      filterable
                      allow-create
                      clearable
                      placeholder="请选择或输入"
                      style="width: 100%;"
                  >
                    <el-option
                        v-for="item in technicalManagerList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </section>

          <section class="transfer-section">
            <div class="transfer-section__title">
              <span class="transfer-section__dot"></span>
              接收方信息
            </div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="接收单位/人" prop="receiveName">
                  <el-input v-model="formzr.receiveName" placeholder="请输入接收单位/人"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="接收方账号" prop="receiveAccount">
                  <el-input v-model="formzr.receiveAccount" placeholder="请输入账号"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="联系电话" prop="receivePhone">
                  <el-input v-model="formzr.receivePhone" placeholder="请输入联系电话"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属区县" prop="areaCodeval">
                  <el-select
                      v-model="formzr.areaCodeval"
                      placeholder="请选择区县"
                      style="width: 100%;"
                      @change="updateAreaCode"
                  >
                    <el-option
                        v-for="item in areaCodeArray"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </section>

          <section class="transfer-section transfer-section--upload">
            <div class="transfer-section__title">
              <span class="transfer-section__dot"></span>
              转让协议
            </div>
            <el-form-item prop="uploadImg" class="transfer-upload-item">
              <el-upload
                  class="transfer-upload"
                  drag
                  :action="UPLOAD_IMAGE_URL"
                  :headers="uploadHeaders"
                  :accept="UPLOAD_ACCEPT"
                  :before-upload="beforeUploadAuth"
                  :on-success="onTransferUploadSuccess"
                  :on-remove="handleFileRemoveImg"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将协议文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持常见文档/图片格式，仅可上传 1 个文件</div>
              </el-upload>
              <div v-if="showimg" class="transfer-preview">
                <img :src="showimg" alt="协议预览"/>
              </div>
            </el-form-item>
          </section>
        </el-form>
      </div>

      <div slot="footer" class="transfer-dialog__footer">
        <el-button size="medium" @click="closeModal">取 消</el-button>
        <el-button size="medium" type="primary" icon="el-icon-check" @click="homeviewSubmit('formzrRef')">
          确定转化
        </el-button>
      </div>
    </el-dialog>

    <!-- 转让审核-添加/修改弹窗 -->
    <el-dialog
        :visible.sync="transferEditDialogVisible"
        width="720px"
        top="6vh"
        append-to-body
        :close-on-click-modal="false"
        custom-class="transfer-dialog"
        @close="closeTransferEdit"
    >
      <div slot="title" class="transfer-dialog__header">
        <div class="transfer-dialog__header-icon">
          <i :class="transferFormMode === 'add' ? 'el-icon-plus' : 'el-icon-edit'"></i>
        </div>
        <div class="transfer-dialog__header-text">
          <div class="transfer-dialog__header-title">
            {{ transferFormMode === 'add' ? '添加转让' : '修改转让信息' }}
          </div>
          <div v-if="transferEditForm.achievementName" class="transfer-dialog__header-sub">
            {{ transferEditForm.achievementName }}
          </div>
        </div>
      </div>

      <div class="transfer-dialog__body">
        <el-form
            ref="transferEditFormRef"
            :model="transferEditForm"
            :rules="transferEditRules"
            label-position="top"
            class="transfer-form"
        >
          <section v-if="transferFormMode === 'add'" class="transfer-section">
            <div class="transfer-section__title">
              <span class="transfer-section__dot"></span>
              选择成果
            </div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="转让人账号" prop="fromUserName">
                  <el-input v-model="transferEditForm.fromUserName" placeholder="请输入转让人手机号"/>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="transfer-form-action-col">
                <el-button type="primary" plain @click="loadTransferAchievements">查询可转让成果</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="24">
                <el-form-item label="选择成果" prop="achievementId">
                  <el-select
                      v-model="transferEditForm.achievementId"
                      placeholder="请先查询并选择成果"
                      filterable
                      style="width: 100%;"
                      @change="onTransferAchievementChange"
                  >
                    <el-option
                        v-for="item in transferAchievementOptions"
                        :key="item.id"
                        :label="item.achievementName"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </section>

          <section v-if="transferFormMode === 'edit'" class="transfer-section">
            <div class="transfer-section__title">
              <span class="transfer-section__dot"></span>
              基本信息
            </div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="成果名称">
                  <el-input v-model="transferEditForm.achievementName" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="转让人">
                  <el-input v-model="transferEditForm.fromUserName" disabled/>
                </el-form-item>
              </el-col>
            </el-row>
          </section>

          <section class="transfer-section">
            <div class="transfer-section__title">
              <span class="transfer-section__dot"></span>
              转让信息
            </div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="转让类型" prop="transferType">
                  <el-select v-model="transferEditForm.transferType" placeholder="请选择转让类型" style="width: 100%;">
                    <el-option
                        v-for="item in currentTransferEditTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="转让时间" prop="transferTime">
                  <el-date-picker
                      v-model="transferEditForm.transferTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="转让金额（万元）" prop="receiveMoney">
                  <el-input v-model="transferEditForm.receiveMoney" placeholder="请输入转让金额">
                    <template slot="prepend">¥</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="技术经理人" prop="technicalManager">
                  <el-select
                      v-model="transferEditForm.technicalManager"
                      filterable
                      allow-create
                      clearable
                      placeholder="请选择或输入"
                      style="width: 100%;"
                  >
                    <el-option
                        v-for="item in technicalManagerList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </section>

          <section class="transfer-section">
            <div class="transfer-section__title">
              <span class="transfer-section__dot"></span>
              接收方信息
            </div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="接收方账号" prop="toUserName">
                  <el-input v-model="transferEditForm.toUserName" placeholder="请输入接收方手机号"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="接收单位/人" prop="receiveName">
                  <el-input v-model="transferEditForm.receiveName" placeholder="请输入接收单位/人"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="联系电话" prop="receivePhone">
                  <el-input v-model="transferEditForm.receivePhone" placeholder="请输入联系电话"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属区县" prop="areaCodeval">
                  <el-select v-model="transferEditForm.areaCodeval" placeholder="请选择区县" style="width: 100%;">
                    <el-option
                        v-for="item in areaCodeArray"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </section>

          <section class="transfer-section transfer-section--upload">
            <div class="transfer-section__title">
              <span class="transfer-section__dot"></span>
              转让协议
            </div>
            <el-form-item prop="uploadAgreementFile" class="transfer-upload-item">
              <el-upload
                  class="transfer-upload"
                  drag
                  :action="UPLOAD_IMAGE_URL"
                  :headers="uploadHeaders"
                  :accept="UPLOAD_ACCEPT"
                  :before-upload="beforeUploadAuth"
                  :on-success="onTransferEditUploadSuccess"
                  :on-remove="handleTransferEditFileRemove"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="transferEditFileList"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将协议文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持常见文档/图片格式，仅可上传 1 个文件</div>
              </el-upload>
            </el-form-item>
          </section>
        </el-form>
      </div>

      <div slot="footer" class="transfer-dialog__footer">
        <el-button size="medium" @click="closeTransferEdit">取 消</el-button>
        <el-button
            size="medium"
            type="primary"
            icon="el-icon-check"
            :loading="transferEditLoading"
            @click="submitTransferEdit"
        >
          {{ transferFormMode === 'add' ? '提 交' : '保 存' }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 审核人填写弹窗 -->
    <el-dialog
        :title="reviewerForm.actionType === 'approve' ? '填写审核信息（通过）' : '填写审核信息（拒绝）'"
        :visible.sync="reviewerDialogVisible"
        width="480px"
        append-to-body
    >
      <el-form :model="reviewerForm" :rules="formRules" ref="reviewerFormRef" label-width="120px">
        <el-form-item label="审核人：" prop="reviewerName">
          <el-input v-model="reviewerForm.reviewerName" placeholder="请输入审核人姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="审核意见：" prop="reviewerComments">
          <el-input
              v-model="reviewerForm.reviewerComments"
              type="textarea"
              :rows="4"
              placeholder="请输入审核意见"
              maxlength="500"
              show-word-limit
              clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reviewerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmReview">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
        title="平台审核记录"
        :visible.sync="reviewLogDialogVisible"
        width="920px"
        append-to-body
    >
      <div v-if="reviewLogTitle" class="review-log-title">{{ reviewLogTitle }}</div>
      <el-table
          v-loading="reviewLogLoading"
          :data="reviewLogList"
          border
          style="width: 100%;"
          empty-text="暂无审核记录"
      >
        <el-table-column prop="reviewTime" label="审核时间" align="center" width="170" show-overflow-tooltip/>
        <el-table-column prop="reviewIp" label="审核IP" align="center" width="130" show-overflow-tooltip>
          <template #default="scope">
            <span>{{ scope.row.reviewIp || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reviewerName" label="审核人" align="center" width="120" show-overflow-tooltip/>
        <el-table-column label="审核结果" align="center" width="100">
          <template #default="scope">
            <span>{{ formatAuditStatus(scope.row.auditStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reviewerComments" label="审核意见" align="left" min-width="180" show-overflow-tooltip/>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reviewLogDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 详情查看弹窗 -->
    <EvidenceDetailDialog
        :visible.sync="detailDialogVisible"
        :form="form"
    />

    <!-- 评估详情弹窗 -->
    <el-dialog
        title="价值评估详情"
        :visible.sync="assessmentDialogVisible"
        width="520px"
        append-to-body
    >
      <el-form label-width="120px" disabled>
        <el-form-item label="自我评估(万元):">
          <el-input v-model="assessmentForm.selfValuation"/>
        </el-form-item>
        <el-form-item label="专家评估(万元):">
          <el-input v-model="assessmentForm.expertValuation"/>
        </el-form-item>
        <el-form-item label="综合评估(万元):">
          <el-input v-model="assessmentForm.comprehensiveEvaluation"/>
        </el-form-item>
        <el-form-item label="自我评估材料:">
          <template v-if="assessmentForm.evaluateSupportingMaterials">
            <el-link type="primary" :underline="false" @click="openAgreementFile(assessmentForm.evaluateSupportingMaterials)">
              {{ getEvidenceFileLabel(assessmentForm.evaluateSupportingMaterials) }}
            </el-link>
          </template>
          <span v-else>-</span>
        </el-form-item>
        <el-form-item label="专家评估材料:">
          <template v-if="assessmentForm.expertValuationMaterialUrl">
            <div v-if="isImageUrl(assessmentForm.expertValuationMaterialUrl)" style="text-align:center;">
              <el-image
                  :src="getFileUrl(assessmentForm.expertValuationMaterialUrl)"
                  style="max-width:100%;max-height:300px;cursor:pointer"
                  :preview-src-list="[getFileUrl(assessmentForm.expertValuationMaterialUrl)]"
                  fit="contain"
              />
            </div>
            <div v-else>
              <el-link type="primary" :underline="false" @click="openAgreementFile(assessmentForm.expertValuationMaterialUrl)">
                {{ getEvidenceFileLabel(assessmentForm.expertValuationMaterialUrl) }}
              </el-link>
            </div>
          </template>
          <span v-else>-</span>
        </el-form-item>
        <el-form-item label="成果评价材料:">
          <template v-if="assessmentForm.uploadFiles">
            <el-link type="primary" :underline="false" @click="openAgreementFile(assessmentForm.uploadFiles)">
              {{ getEvidenceFileLabel(assessmentForm.uploadFiles) }}
            </el-link>
          </template>
          <span v-else>-</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="assessmentDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import {
  putPassword,
  queryViewDetails
} from "@/api/login";
import {download, selectMarket, updateEvidence, updateEvidenceReview, batchUpdateSortNum, regenerateCertificate, getEvidenceReviewLog} from "@/api/certificate";
import {
  commissionList,
  deleteEvidence,
  deleteTemporarily,
  evidenceById, getUnit,
  queryUser,
  temporarilyById,
  temporarilyList,
  updateUserStatus
} from "@/api/http";
import {confirmevidence, achievementTransfersList, changeStatus, changeStatusReview, updateTransfer, registerApplicationList, auditRegisterApplication} from "@/api/login";
import ImgShow from "@/views/imgShow.vue";
import ImagePreview from "@/components/ImagePreview/index.vue";
import Display from "@/views/secondInstance/display.vue";
import EvidenceDetailDialog from "@/components/EvidenceDetailDialog.vue";
import {normalizeSingleLineText} from "@/utils/validate";
import { canDisposeAchievement, getAvailableTransferTypes, getExclusiveTransferDetail, getTransferDetail } from "@/utils/transferRights";
import { getUploadHeaders, UPLOAD_IMAGE_URL, UPLOAD_ACCEPT, beforeUploadAuth, parseUploadResponse, promptReLogin, resolveFileUrl, openUploadedFile, getFileBaseName } from "@/config/upload";
import { Message } from "element-ui";

const SINGLE_LINE_TEXT_FIELDS = [
  'introductionAchievements',
  'coreTechnology',
  'scenarioApplication',
  'marketProspect'
]

export default {
  components: {Display, ImagePreview, ImgShow, EvidenceDetailDialog},
  data() {
    return {
      UPLOAD_IMAGE_URL,
      UPLOAD_ACCEPT,
      beforeUploadAuth,
      //获取可以选择的企业
      unitList: [],
      //暂存记录
      temporaryStorageList: [],
      pageSizeThree: 10,
      pageNumThree: 1,
      pageSizeTwo: 10,
      pageNumTwo: 1,
      holdingUnit: "",
      completionUnit: "",
      achievementName: "",
      pageSizeFist: 10,
      pageNumFirst: 1,
      userName: "",
      dataTime: [],
      activeNameTwo: "first",
      pageSize: 10,
      pageNum: 1,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      isUserListShow: false,
      //用户列表
      userList: [],
      memberListSubTab: 'registered',
      registerApplicationList: [],
      registerAuditQuery: {
        username: '',
        companyName: '',
        auditStatus: null
      },
      registerAuditPageNum: 1,
      registerAuditPageSize: 10,
      registerAuditTotal: 0,
      companyName: '',
      achievementTransfersList: [],
      showModal: false,
      form: {
        scenarioApplication: "",//市场前景
        achievementName: "",//成果名称
        holdingUnit: "",//持有单位/人
        completionUnit: "",//完成单位/人
        phoneNumber: "", //联系电话
        completionTime: "",//完成时间
        introductionAchievements: "",//成果介绍
        coreTechnology: "",//核心技术
        marketProspect: "",//市场前景
        money: "",//金额
        //旧的
        depositSubject: "", // 存证主体
        isThirdParty: false, // 是否为第三方机构
        author: "", // 作者
        authorId: "", // 作者证件
        authorIdNumber: "", // 作者证件号码
        memberId: "", // 会员编号
        uploadFiles: "", // 上传文件
        depositName: "", // 存证名称
        depositType: "", // 存证类型
        equityOwnership: [], // 权益拥有
        originalFilenameUrl: "",//文件上传路径
        evaluationDocuments: "",//评估证书路径
        originalFilenameUrlName: "",//评估证书名
        conversionMethod: "",//转化方式
        //价值评估
        valueAssessment: "",
        //技术领域
        technicalField: "",
        selfValuation: "",       // 自我评估
        expertValuation: "",      // 专家评估
        comprehensiveEvaluation: "", // 综合评估
        expertValuationMaterialUrl: "",
        transferTime: "",
      },
      //二级管理员
      secondaryManagement: {
        companyName: "",
        id: "",
        phone: "",
        password: "",
      },

      transferTypeList: [
        {
          value: 0,  // 实际值
          label: "独家转让"  // 显示文本
        },
        {
          value: 1,
          label: "非独家转让"
        },
        {
          value: 2,  // 实际值
          label: "成果许可"  // 显示文本
        },
        {
          value: 3,
          label:'实施转化'
        },        {
          value: 4,
          label:'作价投资'
        }
      ],
      currentTransferTypeList: [],
      currentTransferEditTypeList: [],
      showimg: '',
      fileList: [],
      formzr: {
        receiveAccount: "",
        receiveMoney: "",
        achievementName: "",//成果名称
        id: "",
        userId: "",
        userName: "",
        loginId: "",
        uploadImg: "",//转让协议文件
        receiveName: "",//接收人名称
        receivePhone: "",//接收人电话
        transferType: 0,//转让类型
        technicalManager: "", //技术经理人
        isAchievement: 1,
        transferTime: ""
      },

      formRules: {
        transferType: [
          {required: true, message: '请选择转让类型', trigger: 'blur'}
        ],
        // technicalManager: [
        //   { required: true, message: '请选择或输入技术经理人', trigger: 'blur' }
        // ],
        areaCodeval:
            [
              {required: true, message: '请选择所属区县', trigger: 'blur'}
            ],
        uploadImg:
            [ // 文件上传必填验证
              {required: true, message: '请上传转让协议', trigger: 'blur'}
            ],
        reviewerName: [
          {required: true, message: '请填写审核人', trigger: 'blur'}
        ],
        reviewerComments: [
          {
            validator: (rule, value, callback) => {
              if (this.reviewerForm.actionTarget === 'review') {
                if (!value || !String(value).trim()) {
                  callback(new Error('请填写审核意见'))
                  return
                }
              }
              callback()
            },
            trigger: 'blur'
          }
        ]
      },

      // 审核人弹窗
      reviewerDialogVisible: false,
      reviewLogDialogVisible: false,
      reviewLogLoading: false,
      reviewLogList: [],
      reviewLogTitle: '',
      // 详情查看弹窗
      detailDialogVisible: false,
      assessmentDialogVisible: false,
      assessmentForm: {
        money: "",
        selfValuation: "",
        expertValuation: "",
        comprehensiveEvaluation: "",
        evaluateSupportingMaterials: "",
        expertValuationMaterialUrl: "",
        uploadFiles: "",
      },
      reviewerForm: {
        row: null,
        reviewerName: '',
        reviewerComments: '',
        actionType: '', // 'approve' 或 'reject'
        actionTarget: '' // 'review' 或 'transfer'
      },

      transferEditDialogVisible: false,
      transferEditLoading: false,
      transferFormMode: 'edit',
      transferAchievementOptions: [],
      transferEditFileList: [],
      transferEditForm: {
        id: '',
        achievementId: '',
        userId: '',
        achievementName: '',
        fromUserName: '',
        toUserName: '',
        receiveName: '',
        receivePhone: '',
        receiveMoney: '',
        transferType: 0,
        transferTime: '',
        technicalManager: '',
        areaCodeval: '',
        uploadAgreementFile: '',
      },
      transferEditRules: {
        fromUserName: [{
          validator: (rule, value, callback) => {
            if (this.transferFormMode === 'add' && !value) {
              callback(new Error('请输入转让人账号'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        achievementId: [{
          validator: (rule, value, callback) => {
            if (this.transferFormMode === 'add' && !value) {
              callback(new Error('请选择成果'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        transferType: [{ required: true, message: '请选择转让类型', trigger: 'change' }],
        receiveMoney: [{ required: true, message: '请输入转让金额', trigger: 'blur' }],
        toUserName: [{ required: true, message: '请输入接收方账号', trigger: 'blur' }],
        receiveName: [{ required: true, message: '请输入接收单位/人', trigger: 'blur' }],
        receivePhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        areaCodeval: [{ required: true, message: '请选择所属区县', trigger: 'change' }],
        uploadAgreementFile: [{ required: true, message: '请上传转让协议', trigger: 'change' }],
      },


      //技术经理人
      technicalManagerList: [],
      showAdmin:
          false,
      activeName:
          "first",
      // 个人信息
      userInfo:
          {
            name: "",
            email:
                "",
            phone:
                "",
            address:
                "",
            companyName:
                "",
            businessLicense:
                "",
            individual:
                0,
          }
      ,
      // 待审核数据
      pendingReview: [],
      rights:
          [
            "自行实施转化",
            "科技成果转让",
            "科技成果许可",
            "合作实施转化",
            "科技成果作价投资",
            "其他",
          ],
      rightsP:
          [
            {label: "自我估值", value: 1},
            {label: "专家估值", value: 2},
            {label: "综合估值", value: 3},
          ],
      technicalFieldList:
          [
            "新一代信息技术产业",
            "高端装备制造产业",
            "新材料产业",
            "生物产业",
            "新能源汽车产业",
            "新能源产业",
            "节能环保产业",
            "数字创意产业",
            "相关服务业",
            "现代食品产业",
            "现代农林渔产业",
            " 医药及医疗器械产业",
            "其他",
          ],
      // 审核失败
      passReview:
          [],
      // 排序相关
      sortField: 'create_time',
      sortOrder: 'desc',
      sortOptions: [
        {label: '提交时间', value: 'create_time'},
        {label: '审核时间', value: 'review_time'},
        {label: '成果名称', value: 'achievement_name'},
        {label: '持有单位/人', value: 'holding_unit'},
        {label: '证书编号', value: 'certificate_no'},
      ],
      sortOrderOptions: [
        {label: '降序', value: 'desc'},
        {label: '升序', value: 'asc'},
      ],
      commissionShow:
          false,
      commissionList:
          [],
      // 审核成功数据
      underReview:
          [],

      areaCodeArray:
          [
            {value: 370902, name: "泰山区"},
            {value: 370911, name: "岱岳区"},
            {value: 370971, name: "高新区"},
            {value: 370983, name: "肥城市"},
            {value: 370982, name: "新泰市"},
            {value: 370921, name: "宁阳县"},
            {value: 370923, name: "东平县"},
            {value: -1, name: "其他地区"},
          ],
      pickerOptions:
          {
            shortcuts: [{
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {

              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }]
          }
      ,
    }
        ;
  },

  computed: {
    uploadHeaders() {
      return getUploadHeaders()
    }
  },

  created() {
    // 组件创建时调用getUserInfo
    this.getuserInfo();
    this.getCheck(2);
    this.isAdmin();
    this.commissionListTab();
    this.getTechnicalManager();
    //获取可以选择的单位
    this.getUnitList();
  },

  methods: {

    canDisposeAchievement,
    getExclusiveTransferDetail,
    getTransferDetail,
    getAvailableTransferTypes,

    //获取可以选择的单位
    getUnitList() {
      getUnit().then(res => {
        if (res.code === 200) {
          this.unitList = res.data;
        } else {

        }
      })
    },

    openImgShow(item) {
      window.open('/imgShow?url=' + item)
    },
    getTechnicalManager() {
      selectMarket().then(res => {
        console.log("res", res);
        console.log("res.code", res.code);
        if (res.code === 200) {
          // this.technicalManagerList = res.data
          this.technicalManagerList = res.data.filter(item => {
            return item.name != null && item.name.trim() !== ""; // 过滤掉 null 和空字符串
          });
        }
      })

    },

    filterCompanyName() {
      this.queryUser();
    },
    //修改存证
    changeCertificateDeposit(id) {
      this.$emit('changeMessage', id);
    },

    //点击修改
    changeMessage(id) {
      console.log('----------------------')
      this.$emit('updateMessage', id);
    },

    normalizeFormTextFields(form) {
      SINGLE_LINE_TEXT_FIELDS.forEach(key => {
        if (form[key] != null) {
          form[key] = normalizeSingleLineText(form[key])
        }
      })
    },

    //根据id寻找暂存记录
    temporarilyById(id) {
      temporarilyById(id).then(res => {
        if (res.code === 200) {
          this.form = res.data;
          this.normalizeFormTextFields(this.form);
          this.commissionTwoShow = true;
          this.isDisabled = false;
        }
      })
    },

    //根据id删除暂存数据
    deleteTemporarilyById(id) {
      this.$confirm('确定要删除该条暂存记录吗？删除后无法恢复。', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTemporarily(id).then(res => {
          this.getTemporarilyList();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(err => {
          this.$message({
            type: 'error',
            message: '删除失败: ' + (err.message || '未知错误')
          });
        });
      }).catch(() => {});
    },

    getTemporarilyList() {
      const userId = localStorage.getItem("userId");
      const param = {
        userId: userId
      };

      temporarilyList(param).then(res => {
        if (res.code === 200) {
          this.temporaryStorageList = res.rows
          this.total = res.total
        }
      })
    },
    //删除存证
    deleteCertificateDeposit(id, item) {
      this.$confirm('确定要删除该条存证记录吗？删除后无法恢复。', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteEvidence(id).then(res => {
          this.resetSearch(item);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(err => {
          this.$message({
            type: 'error',
            message: '删除失败: ' + (err.message || '未知错误')
          });
        });
      }).catch(() => {});
    },
    // 更新 form.areaCode 的值
    updateAreaCode(selectElement) {
      this.form.areaCodeval = selectElement;
    },
    //展示图片
    onTransferUploadSuccess(response, file, fileList) {
      const result = parseUploadResponse(response)
      if (!result.ok) {
        if (result.expired) promptReLogin()
        else Message.error(result.msg)
        return
      }
      this.formzr.uploadImg = result.data.newName
      this.fileList = fileList
    },
    handleUploadimg(data, file, fileList) {
      this.formzr.uploadImg = data.data.newName
      this.fileList = fileList
    },
    handleFileRemoveImg(file, fileList) {
      this.formzr.uploadImg = ""
      this.fileList = fileList
    },
    handleExceed(files, fileList) {
      // 当超过文件限制时的处理
      this.$message.warning('只能上传一个文件，请先移除已有的文件再上传新的文件');
    },

    //打开转让弹窗
    openModal(row) {
      console.log("row", row);
      this.currentTransferTypeList = getAvailableTransferTypes(this.transferTypeList, row || {});
      this.formzr.id = row.id;
      this.formzr.userId = row.userId;
      this.formzr.userName = row.userName;
      this.formzr.achievementName = row.achievementName;
      this.formzr.author = row.author;
      this.formzr.authorIdNumber = row.authorIdNumber;
      this.formzr.depositName = row.depositName;
      this.formzr.depositSubject = row.depositSubject;
      this.formzr.depositType = row.depositType;
      this.formzr.memberId = row.memberId;
      this.formzr.uploadFiles = row.uploadFiles;
      this.formzr.transferType = this.currentTransferTypeList.length
          ? this.currentTransferTypeList[0].value
          : 2;
      this.fileList = [];
      this.formzr.uploadImg = "";
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.fileList = [];
      this.formzr.uploadImg = "";
    },
    queryUserClean() {
      this.userName = ""
      this.companyName = ""
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        userName: this.userName
      }
      queryUser(params).then(res => {
        this.userList = res.rows;
        this.total = res.total;

      })
    },
    queryUser() {
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        userName: this.userName,
        companyName: this.companyName
      }
      queryUser(params).then(res => {
        this.userList = res.rows;
        this.total = res.total
        console.log("res", res.rows);
        console.log("res", res.rows.individual);
        console.log("this.userList.individual", this.userList.individual);
        console.log("this.userList.individual", this.userList.individual === 1);
      })
    },
    handleSizeChangeUser(val) {
      this.pageSize = val
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }
      queryUser(params).then(res => {
        this.userList = res.rows;
        this.total = res.total
      })
    },
    handleCurrentChangeUser(item) {
      const params = {
        pageSize: this.pageSize,
        pageNum: item,
      }
      queryUser(params).then(res => {
        this.userList = res.rows;
        this.total = res.total
      })
    },
    con() {
      const param = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        userName: this.userName

      }
      commissionList(param).then(res => {
        this.total = res.total
        this.commissionList = res.rows;
      })
    },
    conClean() {
      this.userName = ""
      const param = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }
      commissionList(param).then(res => {
        this.total = res.total
        this.commissionList = res.rows;
      })
    },

    resetSearch(item) {
      this.userName = ""
      this.achievementName = ""
      this.dataTime = []
      this.holdingUnit = ""
      this.completionUnit = ""
      if (item === 2) {
        this.sortField = 'create_time'
        this.sortOrder = 'desc'
      }
      var userId = localStorage.getItem("userId");
      if (userId == null) {
        alert("请先登录");
      }

      const data = {
        auditStatus: item,
        userId: userId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        userName: this.userName,
        sortField: item === 2 ? this.sortField : undefined,
        sortOrder: item === 2 ? this.sortOrder : undefined,
      }

      queryViewDetails(data).then(response => {
        if (item === 2) {
          this.passReview = response.rows
          this.total = response.total
        } else if (item === 1) {
          this.underReview = response.rows
          this.total = response.total
        } else if (item === 0) {
          this.pendingReview = response.rows
          this.total = response.total
        }
      })
    },

    filterByPhoneNumber(item) {
      let formattedStart;
      let formattedEnd;
      if (this.dataTime.length > 0) {
        function formatDate(date) {
          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, '0');
          const d = String(date.getDate()).padStart(2, '0');
          const h = String(date.getHours()).padStart(2, '0');
          const min = String(date.getMinutes()).padStart(2, '0');
          const s = String(date.getSeconds()).padStart(2, '0');
          return `${y}-${m}-${d} ${h}:${min}:${s}`;
        }

        const [startDate, endDate] = this.dataTime;
        formattedStart = formatDate(startDate); // "2025-02-27"
        formattedEnd = formatDate(endDate);     // "2025-05-28"
        console.log('formattedStart', formattedStart);
        console.log('formattedEnd', formattedEnd);
      }

      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }

      if (item == 2) {
        this.pageNum = this.pageNumFirst
        this.pageSize = this.pageSizeFist
      } else if (item == 1) {
        this.pageNum = this.pageNumTwo
        this.pageSize = this.pageSizeTwo
      } else if (item == 0) {
        this.pageNum = this.pageNumThree
        this.pageSize = this.pageSizeThree
      }
      const data = {
        auditStatus: item,
        userId: userId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        userName: this.userName,
        achievementName: this.achievementName,
        formattedStart: formattedStart,
        formattedEnd: formattedEnd,
        holdingUnit: this.holdingUnit,
        completionUnit: this.completionUnit,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      }
      console.log("imte", item);
      return queryViewDetails(data).then(response => {
        console.log("imte", item);
        if (item == 2) {
          this.passReview = response.rows
          this.total = response.total
          console.log("passReview", this.passReview)
        } else if (item == 1) {
          this.underReview = response.rows
          this.total = response.total
          console.log("underReview", this.underReview)
        } else if (item == 0) {
          this.pendingReview = response.rows
          this.total = response.total
        }
        return response
      })
    },

    handleSizeChangeFirst(val) {
      console.log("val", val);
      this.pageSizeFist = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 2,
        userId: userId,
        pageSize: this.pageSizeFist,
        pageNum: this.pageNum,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.passReview = response.rows
        this.total = response.total
      })

    },
    handleCurrentChangeFirst(val) {
      this.pageNumFirst = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 2,
        userId: userId,
        pageSize: this.pageSizeFist,
        pageNum: this.pageNumFirst,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.passReview = response.rows
        this.total = response.total
      })
    },


    handleSizeChangeTwo(val) {
      console.log("gothis")
      this.pageSizeTwo = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 1,
        userId: userId,
        pageSize: this.pageSizeTwo,
        pageNum: this.pageNumTwo,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.underReview = response.rows
        this.total = response.total
      })

    },
    handleCurrentChangeTwo(val) {
      console.log("gothis", 1)
      this.pageNumTwo = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 1,
        userId: userId,
        pageSize: this.pageSizeTwo,
        pageNum: this.pageNumTwo,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.underReview = response.rows
        this.total = response.total
      })
    },
    handleSizeChangeThree(val) {
      this.pageSizeThree = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 0,
        userId: userId,
        pageSize: this.pageSizeThree,
        pageNum: this.pageNumThree,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.pendingReview = response.rows
        this.total = response.total
      })

    },
    handleCurrentChangeThree(val) {
      this.pageNumThree = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 0,
        userId: userId,
        pageSize: this.pageSizeThree,
        pageNum: this.pageNumThree,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.pendingReview = response.rows
        this.total = response.total
      })
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.commissionListTab()

    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val
      this.commissionListTab()
    },


    resetPassword(item) {
      console.log("item", item);
      this.userId = localStorage.getItem("userId")
      console.log("userID", this.userId);
      const data = {
        password: '123456',
        phone: item.userName
      }
      putPassword(data).then(res => {
        console.log("res", res);
        if (res.code === 200) {
          this.$message({
            message: '重置成功，密码为：‘123456’，请联系用户通过找回密码功能修改自己密码',
            type: 'success',
            duration: 3000,
            showClose: true
          })
        }
      })
    },

    toggleUserStatus(row, status) {
      const actionText = status === '1' ? '禁用' : '启用';
      this.$confirm(`确认${actionText}账号「${row.userName}」吗？${status === '1' ? '禁用后该用户将无法登录。' : ''}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateUserStatus({
          userId: row.userId,
          status: status
        }).then(res => {
          if (res.code === 200) {
            Message.success(`${actionText}成功`);
            this.queryUser();
          } else {
            Message.error(res.msg || `${actionText}失败`);
          }
        })
      }).catch(() => {});
    },

    toExamine() {
      this.isUserListShow = false;
    },
    toExamine() {
      this.isDisabled = true;
      this.toExamine();
      this.isUserListShow = true;

    },
    toUser() {
      this.queryUserList();
      this.isUserListShow = true;
    },
    goBack() {
      // console.log("走了吗");
      this.commissionShow = false;
    },

    queryUserList() {
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }
      queryUser(params).then(res => {
        this.userList = res.rows;
        this.total = res.total
      })
    },
    //

    evidenceById(item) {
      evidenceById(item).then(res => {
        this.form = res.data
        this.normalizeFormTextFields(this.form);
        this.form.conversionMethod = res.data.conversionMethod.split(",")
        this.detailDialogVisible = true;
      })
    },

    //
    commissionListTab() {
      const param = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,

      }
      commissionList(param).then(res => {
        console.log("res.c", res.rows);
        this.total = res.total
        this.commissionList = res.rows;
      })
    },

    rightText(right) {
      return right.replace("（查看)", "");
    },

    formatValueAssessment(row) {
      const parts = []
      const selfVal = row.selfValuation || row.money
      if (selfVal) parts.push('自我')
      if (row.expertValuation) parts.push('专家')
      if (row.comprehensiveEvaluation) parts.push('综合')
      if (parts.length) return parts.join('/')
      const type = row && row.valueAssessment != null ? String(row.valueAssessment) : ''
      const map = { '1': '自我', '2': '专家', '3': '自我/专家/综合' }
      return map[type] || '-'
    },
    viewContent(data) {
      const selfVal = data.selfValuation || (data.valueAssessment == 1 || data.valueAssessment === '1' ? data.money : '') || ''
      this.assessmentForm = {
        valueAssessment: data.valueAssessment,
        money: data.money || '',
        selfValuation: selfVal,
        expertValuation: data.expertValuation || (data.valueAssessment == 2 || data.valueAssessment === '2' ? data.money : '') || '',
        comprehensiveEvaluation: data.comprehensiveEvaluation || '',
        evaluateSupportingMaterials: data.evaluateSupportingMaterials || '',
        expertValuationMaterialUrl: data.comprehensiveEvaluationFileUrl || data.expertValuationMaterialUrl || data.evaluationDocuments || '',
        uploadFiles: data.uploadFiles || '',
      };
      this.assessmentDialogVisible = true;
    },
    openUrl(url) {
      window.open(url)
      window.open(url + "?refresh=" + new Date().getTime());
    },
    isImageUrl(url) {
      if (!url) return false;
      const ext = url.split('.').pop()?.toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext);
    },
    getFileUrl(filename) {
      return resolveFileUrl(filename);
    },

    getEvidenceFileLabel(path) {
      return getFileBaseName(path) || path || '-';
    },

    openAgreementFile(path) {
      openUploadedFile(path);
    },

    async handleDownload(row) {
      // 设置下载状态
      window.location.href = 'https://kejichengguo.tskjdsc.com/dev-api/evidence/download/' + row.id
    },

    // 保存排序
    saveSort() {
      const sortList = this.passReview.map(item => ({
        id: item.id,
        sort: item.sort
      }));
      batchUpdateSortNum(sortList).then(res => {
        if (res.code === 200) {
          this.$message.success('排序保存成功');
          this.getCheck(2);
        } else {
          this.$message.error(res.msg || '保存失败');
        }
      }).catch(() => {
        this.$message.error('保存失败');
      });
    },

    formatUnitReviewTime(row) {
      const v = row.unitReviewTime != null ? row.unitReviewTime : row.unit_review_time;
      if (v === null || v === undefined || v === '') {
        return '—';
      }
      if (typeof v === 'number') {
        const d = new Date(v);
        if (!isNaN(d.getTime())) {
          const pad = n => String(n).padStart(2, '0');
          return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        }
      }
      return String(v);
    },

    formatAuditStatus(status) {
      const val = Number(status);
      if (val === 2) return '审核通过';
      if (val === 1) return '审核失败';
      if (val === 0) return '审核中';
      return '—';
    },

    openReviewLog(row) {
      if (!row || !row.id) return;
      this.reviewLogTitle = row.achievementName ? `成果：${row.achievementName}` : '';
      this.reviewLogDialogVisible = true;
      this.reviewLogLoading = true;
      this.reviewLogList = [];
      getEvidenceReviewLog(row.id)
          .then((res) => {
            const data = res && res.data !== undefined ? res.data : res;
            this.reviewLogList = Array.isArray(data) ? data : (data && Array.isArray(data.data) ? data.data : []);
          })
          .catch(() => {
            this.$message.error('获取审核记录失败');
          })
          .finally(() => {
            this.reviewLogLoading = false;
          });
    },

    handleRegenerateCertificate(row) {
      this.$confirm('确定重新生成该条存证的电子证书？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const evidenceId = row.id
        this.$set(row, 'regeneratingCertificate', true);
        regenerateCertificate(evidenceId)
          .then((res) => {
            if (res.code != null && Number(res.code) !== 200) {
              this.$message.error(res.msg || '操作失败');
              return Promise.resolve();
            }
            let newUrl = null;
            const d = res.data;
            if (d != null && d !== '') {
              newUrl = typeof d === 'string' ? d : (d.certificateUrl || d.url);
            }
            // 先等列表按当前筛选条件拉取完成（新行对象），再写回 URL，最后提示成功，避免「提示了但行上仍是旧链接」
            return this.filterByPhoneNumber(2)
              .then(() => {
                if (newUrl) {
                  const cur = this.passReview.find((r) => r.id === evidenceId);
                  if (cur) {
                    this.$set(cur, 'certificateUrl', newUrl);
                  }
                }
                this.$message.success(res.msg || '已重新生成证书');
              })
              .catch(() => {
                this.$message.error('证书已生成，但刷新列表失败，请手动点击查询');
              });
          })
          .catch(() => {
            this.$message.error('请求失败');
          })
          .finally(() => {
            this.$set(row, 'regeneratingCertificate', false);
          });
      }).catch(() => {
      });
    },

    handleApprove(row) {
      if (row.unitReview === 0) {
        this.$message({
          message: '持有单位暂未审核，请通知持有单位审核',
          type: 'success',
          duration: 3000,
          showClose: true,
          offset: 300
        })

      } else if (row.unitReview === 2) {
        this.$message({
          message: '该审核已失败，请拒绝审核',
          type: 'success',
          duration: 3000,
          showClose: true,
          offset: 300
        })
      } else {
        this.reviewerForm.row = row;
        this.reviewerForm.reviewerName = '';
        this.reviewerForm.reviewerComments = '';
        this.reviewerForm.actionType = 'approve';
        this.reviewerForm.actionTarget = 'review';
        this.reviewerDialogVisible = true;
      }
    },
    confirmReview() {
      this.$refs.reviewerFormRef.validate((valid) => {
        if (!valid) return;
        const row = this.reviewerForm.row;
        const reviewerName = this.reviewerForm.reviewerName;
        const reviewerComments = this.reviewerForm.reviewerComments;
        const actionType = this.reviewerForm.actionType;
        const actionTarget = this.reviewerForm.actionTarget;
        const pad = n => String(n).padStart(2, '0');
        const d = new Date();
        const reviewTime = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        this.reviewerDialogVisible = false;

        if (actionTarget === 'review') {
          const auditStatus = actionType === 'approve' ? 2 : 1;
          const data = {
            id: row.id,
            auditStatus: auditStatus,
            reviewerName: reviewerName,
            reviewerComments: reviewerComments,
            reviewTime: reviewTime
          };
          updateEvidence(data).then(responses => {
            this.$message({
              message: actionType === 'approve' ? '该审核已通过' : '审核已拒绝',
              type: actionType === 'approve' ? 'success' : 'error',
              duration: 3000,
              showClose: true,
              offset: 300
            });
            this.getCheck(0);
            if (actionType === 'approve') {
              this.getCheck(2);
            } else {
              this.getCheck(1);
              this.getCheck(2);
            }
          });
        } else if (actionTarget === 'transfer') {
          const status = actionType === 'approve' ? 2 : 1;
          const data = {
            id: row.id,
            status: status,
            reviewer_name: reviewerName,
            review_time: reviewTime
          };
          changeStatusReview(data).then(responses => {
            this.$message({
              message: actionType === 'approve' ? '该审核已通过' : '审核已拒绝',
              type: actionType === 'approve' ? 'success' : 'error',
              duration: 3000,
              showClose: true,
              offset: 300
            });
            this.getAchievementList();
          });
        }
      });
    },
    /** 管理端退回已通过成果，用户方可修改并重新提交 */
    handleReturn(row) {
      this.$confirm('退回后该成果将变为审核失败，用户可修改并重新提交，是否继续？', '退回确认', {
        confirmButtonText: '确定退回',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.reviewerForm.row = row;
        this.reviewerForm.reviewerName = '';
        this.reviewerForm.reviewerComments = '';
        this.reviewerForm.actionType = 'reject';
        this.reviewerForm.actionTarget = 'review';
        this.reviewerDialogVisible = true;
      }).catch(() => {});
    },
    handleReject(row) {

      if (row.unitReview === 0) {
        this.$message({
          message: '持有单位暂未审核，请通知持有单位审核',
          type: 'success',
          duration: 3000,
          showClose: true,
          offset: 300
        })

      } else {
        this.reviewerForm.row = row;
        this.reviewerForm.reviewerName = '';
        this.reviewerForm.reviewerComments = '';
        this.reviewerForm.actionType = 'reject';
        this.reviewerForm.actionTarget = 'review';
        this.reviewerDialogVisible = true;
      }
    },

    isAdmin() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId === '1') {
        this.showAdmin = true
        console.log("1")
      } else {
        this.showAdmin = false
      }
// 假设token解析后的格式是这样的：{ "role": "admin" }
// 判断用户是否为管理员
      if (userId === 'admin') {
        // 是管理员的处理逻辑
        console.log('当前用户是管理员');
      } else {
        // 不是管理员的处理逻辑
        console.log('当前用户不是管理员');
      }
    },

    //个人信息
    getuserInfo() {
      var userInfos = localStorage.getItem("userInfos");
      // 将JSON字符串解析回对象，并赋值给组件的data属性
      var userInfoObj = JSON.parse(userInfos);
      // 正确的赋值方式
      this.userInfo.name = userInfoObj.userName; // 注意这里是赋值，不是函数调用
      this.userInfo.email = userInfoObj.email;
      this.userInfo.phone = userInfoObj.phonenumber; // 注意这里应该是phonenumber，而不是email
      this.userInfo.companyName = userInfoObj.companyName;
      this.userInfo.businessLicense = userInfoObj.businessLicense;
      this.userInfo.individual = userInfoObj.individual;
    },
    handleClick(tab, event) {
      this.userName = ""
      this.achievementName = ""
      if (tab.index === "0") {
        this.getCheck(2);
      } else if (tab.index === "1") {
        this.getCheck(1);
      } else if (tab.index === "2") {
        this.getCheck(0);
      } else if (tab.index === "3") {
        this.commissionListTab()
      }
    },
    handleClickTwo(tab, event) {
      this.userName = ""
      this.achievementName = ""

      if (tab.name === 'first') {
        this.getCheck(2)
      } else if (tab.name === 'two') {
        this.loadMemberListSubTab();
      } else if (tab.name === 'three') {
        this.getAchievementList();
      } else if (tab.name === 'six') {
        this.getTemporarilyList()
      }
    },
    handleMemberListSubTab(tab) {
      if (tab.name === 'registerAudit') {
        this.queryRegisterApplicationList();
      } else {
        this.queryUserList();
      }
    },
    loadMemberListSubTab() {
      if (this.memberListSubTab === 'registerAudit' && this.showAdmin) {
        this.queryRegisterApplicationList();
      } else {
        this.memberListSubTab = 'registered';
        this.queryUserList();
      }
    },
    queryRegisterApplicationList() {
      const params = {
        pageNum: this.registerAuditPageNum,
        pageSize: this.registerAuditPageSize,
        username: this.registerAuditQuery.username || undefined,
        companyName: this.registerAuditQuery.companyName || undefined,
        auditStatus: this.registerAuditQuery.auditStatus
      }
      if (params.auditStatus === '' || params.auditStatus === null || params.auditStatus === undefined) {
        delete params.auditStatus
      }
      registerApplicationList(params).then(res => {
        this.registerApplicationList = res.rows || [];
        this.registerAuditTotal = res.total || 0;
      })
    },
    resetRegisterApplicationQuery() {
      this.registerAuditQuery = {
        username: '',
        companyName: '',
        auditStatus: null
      };
      this.registerAuditPageNum = 1;
      this.queryRegisterApplicationList();
    },
    handleRegisterAuditSizeChange(val) {
      this.registerAuditPageSize = val;
      this.registerAuditPageNum = 1;
      this.queryRegisterApplicationList();
    },
    handleRegisterAuditCurrentChange(val) {
      this.registerAuditPageNum = val;
      this.queryRegisterApplicationList();
    },
    auditRegisterApplication(row, auditStatus) {
      const actionText = auditStatus === 2 ? '通过' : '拒绝';
      const submitAudit = (reviewRemark) => {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        auditRegisterApplication({
          id: row.id,
          auditStatus: auditStatus,
          reviewerName: userInfo.userName || userInfo.nickName || '',
          reviewRemark: reviewRemark || ''
        }).then(res => {
          if (res.code === 200) {
            Message.success(`审核${actionText}成功`);
            this.queryRegisterApplicationList();
            if (auditStatus === 2) {
              this.queryUserList();
            }
          } else {
            Message.error(res.msg || `审核${actionText}失败`);
          }
        })
      };
      if (auditStatus === 1) {
        this.$prompt('请输入拒绝原因（选填，将展示给申请人）', '拒绝注册申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入审核说明'
        }).then(({ value }) => {
          submitAudit(value);
        }).catch(() => {});
        return;
      }
      this.$confirm(`确认${actionText}该注册申请吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        submitAudit('');
      }).catch(() => {});
    },
    getCheck(status) {
      //获取审核信息
      var userId = localStorage.getItem("userId");
      if (userId == null) {
        alert("请先登录");
      }
      if (status === 2) {
        this.pageNum = this.pageNumFirst
        this.pageSize = this.pageSizeFist
      } else if (status === 1) {
        this.pageNum = this.pageNumTwo
        this.pageSize = this.pageSizeTwo
      } else if (status === 0) {
        this.pageNum = this.pageNumThree
        this.pageSize = this.pageSizeThree
      }
      const data = {
        auditStatus: status,
        userId: userId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      }
      queryViewDetails(data).then(response => {
        if (status === 2) {
          this.passReview = response.rows
          this.total = response.total;
        } else if (status === 1) {
          this.underReview = response.rows
          this.total = response.total;
        } else if (status === 0) {
          this.pendingReview = response.rows
          this.total = response.total;
        }
      }).catch(error => {
        console.error("请求失败", error);
      });
    },

    //转让实现
    homeviewSubmit(formzrRef) {
      var userId = localStorage.getItem("userId");
      this.$refs[formzrRef].validate((valid) => {
        if (valid) {
          const loginData = {
            id: this.formzr.id,
            userId: this.formzr.userId,
            userName: this.formzr.userName,
            achievementName: this.formzr.achievementName,
            loginId: userId,
            receiveAccount: this.formzr.receiveAccount,
            receiveMoney: this.formzr.receiveMoney,
            uploadAgreementFile: this.formzr.uploadImg,
            receiveName: this.formzr.receiveName,
            receivePhone: this.formzr.receivePhone,
            areaCodeval: this.formzr.areaCodeval,
            technicalManager: this.formzr.technicalManager,
            transferType: this.formzr.transferType,
            transferTime: this.formzr.transferTime,
          };
          Object.assign(loginData, this.formrz);
          confirmevidence(loginData).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '您的申请已提交，请耐心等待审核',
                type: 'success',
                duration: 3000,
                showClose: true,
                offset: 200
              })
              //清空内容
              this.cleanForm();
              this.showModal = false;
              this.getCheck(2);
            } else {
              //this.$message.error('提交失败')
            }
          }).catch(err => {
            this.$message.error('提交异常')
          })
        } else {
          this.$message.error('请检查必填的数据');
          return false;
        }
      });
    },
    //清空表单
    cleanForm() {
      this.formzr.receiveAccount = "";
      this.formzr.receiveMoney = "";
    },
    //转让信息列表
    getAchievementList() {
      this.pageNum = 1
      this.userName = ''
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }
      //alert("查询转让列表");
      var userId = localStorage.getItem("userId");
      console.log(userId);
      if (this.showAdmin) {
        //alert("当前是管理员");
        //查全部
        achievementTransfersList(params).then(res => {
          console.log(res);
          this.achievementTransfersList = res.rows;
          this.total = res.total
        })
      } else {
        alert("当前不是管理员");
        //查转让人或接收人是自己的数据
      }
    },
    handleApprove3(row) {
      this.reviewerForm.row = row;
      this.reviewerForm.reviewerName = '';
      this.reviewerForm.reviewerComments = '';
      this.reviewerForm.actionType = 'approve';
      this.reviewerForm.actionTarget = 'transfer';
      this.reviewerDialogVisible = true;
    },
    handleReject3(row) {
      this.reviewerForm.row = row;
      this.reviewerForm.reviewerName = '';
      this.reviewerForm.reviewerComments = '';
      this.reviewerForm.actionType = 'reject';
      this.reviewerForm.actionTarget = 'transfer';
      this.reviewerDialogVisible = true;
    },

    refreshTransferAuditList() {
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
      if (this.userName) {
        params.fromUserName = this.userName;
      }
      achievementTransfersList(params).then(res => {
        this.achievementTransfersList = res.rows;
        this.total = res.total;
      });
    },

    formatTransferTypeLabel(value) {
      const type = Number(value);
      const item = this.transferTypeList.find(row => row.value === type);
      return item ? item.label : (value != null && value !== '' ? value : '—');
    },

    openTransferEdit(row) {
      this.transferFormMode = 'edit';
      this.transferAchievementOptions = [];
      this.transferEditForm = {
        id: row.id,
        achievementId: row.achievementId || '',
        userId: row.fromUserId || '',
        achievementName: row.achievementName || '',
        fromUserName: row.fromUserName || '',
        toUserName: row.toUserName || '',
        receiveName: row.receiveName || '',
        receivePhone: row.receivePhone || '',
        receiveMoney: row.receiveMoney != null ? String(row.receiveMoney) : '',
        transferType: row.transferType != null && row.transferType !== '' ? Number(row.transferType) : 0,
        transferTime: row.transferTime || '',
        technicalManager: row.technicalManager || '',
        areaCodeval: row.areaCodeval != null && row.areaCodeval !== '' ? Number(row.areaCodeval) : '',
        uploadAgreementFile: row.uploadAgreementFile || '',
      };
      this.transferEditFileList = row.uploadAgreementFile
        ? [{ name: '转让协议', url: resolveFileUrl(row.uploadAgreementFile) }]
        : [];
      this.transferEditDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.transferEditFormRef) {
          this.$refs.transferEditFormRef.clearValidate();
        }
      });
    },

    openTransferAdd() {
      this.transferFormMode = 'add';
      this.transferAchievementOptions = [];
      this.transferEditForm = {
        id: '',
        achievementId: '',
        userId: '',
        achievementName: '',
        fromUserName: '',
        toUserName: '',
        receiveName: '',
        receivePhone: '',
        receiveMoney: '',
        transferType: 0,
        transferTime: '',
        technicalManager: '',
        areaCodeval: '',
        uploadAgreementFile: '',
      };
      this.transferEditFileList = [];
      this.transferEditDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.transferEditFormRef) {
          this.$refs.transferEditFormRef.clearValidate();
        }
      });
    },

    loadTransferAchievements() {
      if (!this.transferEditForm.fromUserName) {
        this.$message.warning('请先输入转让人账号');
        return;
      }
      const data = {
        auditStatus: 2,
        userId: localStorage.getItem('userId'),
        pageSize: 100,
        pageNum: 1,
        userName: this.transferEditForm.fromUserName,
      };
      queryViewDetails(data).then(response => {
        const rows = response.rows || [];
        this.transferAchievementOptions = rows.filter(item => canDisposeAchievement(item));
        if (!this.transferAchievementOptions.length) {
          this.$message.info('未找到该账号下可转让的已审核成果');
        }
      });
    },

    onTransferAchievementChange(achievementId) {
      const item = this.transferAchievementOptions.find(row => row.id === achievementId);
      if (!item) {
        return;
      }
      this.transferEditForm.achievementId = item.id;
      this.transferEditForm.achievementName = item.achievementName;
      this.transferEditForm.userId = item.userId;
      this.transferEditForm.fromUserName = item.userName;
      this.currentTransferEditTypeList = getAvailableTransferTypes(this.transferTypeList, item);
      if (!this.currentTransferEditTypeList.some(type => type.value === this.transferEditForm.transferType)) {
        this.transferEditForm.transferType = this.currentTransferEditTypeList.length
            ? this.currentTransferEditTypeList[0].value
            : 2;
      }
    },

    closeTransferEdit() {
      this.transferEditDialogVisible = false;
      this.transferEditLoading = false;
      this.transferEditFileList = [];
      this.transferAchievementOptions = [];
      this.transferFormMode = 'edit';
    },

    onTransferEditUploadSuccess(response, file, fileList) {
      const result = parseUploadResponse(response);
      if (!result.ok) {
        if (result.expired) promptReLogin();
        else Message.error(result.msg);
        return;
      }
      this.transferEditForm.uploadAgreementFile = result.data.newName;
      this.transferEditFileList = fileList;
    },

    handleTransferEditFileRemove(file, fileList) {
      this.transferEditForm.uploadAgreementFile = '';
      this.transferEditFileList = fileList;
    },

    submitTransferEdit() {
      this.$refs.transferEditFormRef.validate(valid => {
        if (!valid) {
          return;
        }
        this.transferEditLoading = true;
        if (this.transferFormMode === 'add') {
          const loginData = {
            id: this.transferEditForm.achievementId,
            userId: this.transferEditForm.userId,
            userName: this.transferEditForm.fromUserName,
            achievementName: this.transferEditForm.achievementName,
            loginId: localStorage.getItem('userId'),
            receiveAccount: this.transferEditForm.toUserName,
            receiveMoney: Number(this.transferEditForm.receiveMoney),
            uploadAgreementFile: this.transferEditForm.uploadAgreementFile,
            receiveName: this.transferEditForm.receiveName,
            receivePhone: this.transferEditForm.receivePhone,
            areaCodeval: this.transferEditForm.areaCodeval,
            technicalManager: this.transferEditForm.technicalManager,
            transferType: this.transferEditForm.transferType,
            transferTime: this.transferEditForm.transferTime,
          };
          confirmevidence(loginData).then(res => {
            if (res.code === 200) {
              this.$message.success('添加成功，请等待审核');
              this.closeTransferEdit();
              this.refreshTransferAuditList();
            } else {
              this.$message.error(res.msg || '添加失败');
            }
          }).catch(() => {
            this.$message.error('添加异常');
          }).finally(() => {
            this.transferEditLoading = false;
          });
          return;
        }
        const payload = {
          id: this.transferEditForm.id,
          toUserName: this.transferEditForm.toUserName,
          receiveName: this.transferEditForm.receiveName,
          receivePhone: this.transferEditForm.receivePhone,
          receiveMoney: Number(this.transferEditForm.receiveMoney),
          transferType: this.transferEditForm.transferType,
          transferTime: this.transferEditForm.transferTime,
          technicalManager: this.transferEditForm.technicalManager,
          areaCodeval: this.transferEditForm.areaCodeval,
          uploadAgreementFile: this.transferEditForm.uploadAgreementFile,
        };
        updateTransfer(payload).then(res => {
          if (res.code === 200) {
            this.$message.success('修改成功');
            this.closeTransferEdit();
            this.refreshTransferAuditList();
          } else {
            this.$message.error(res.msg || '修改失败');
          }
        }).catch(() => {
          this.$message.error('修改异常');
        }).finally(() => {
          this.transferEditLoading = false;
        });
      });
    },

    queryUserzr() {
      this.pageNum = 1
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        fromUserName: this.userName
      }
      localStorage.getItem("unInfos")
      var userId = localStorage.getItem("userId");
      console.log(userId);
      if (this.showAdmin) {
        //alert("当前是管理员");
        console.log("当前是管理员");

        //查全部
        achievementTransfersList(params).then(res => {
          console.log(res);
          this.achievementTransfersList = res.rows;
          this.total = res.total
        })
      } else {
        alert("当前不是管理员");
        //查转让人或接收人是自己的数据
      }
    },

    handleSizeChangeUser3(val) {
      this.pageSize = val
      this.pageNum = 1
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        fromUserName: this.userName || undefined
      }

      localStorage.setItem("userINfo")
      var userId = localStorage.getItem("userId");
      console.log(userId);
      if (this.showAdmin) {
        //alert("当前是管理员");
        console.log("当前是管理员");
        //查全部
        achievementTransfersList(params).then(res => {
          this.achievementTransfersList = res.rows;
          this.total = res.total
        })
      } else {
        alert("当前不是管理员");
        //查转让人或接收人是自己的数据
      }
    },

    handleCurrentChangeUser3(item) {
      this.pageNum = item
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        fromUserName: this.userName || undefined
      }
      var userId = localStorage.getItem("userId");
      console.log(userId);
      if (this.showAdmin) {
        //alert("当前是管理员");
        console.log("当前是管理员");
        //查全部
        achievementTransfersList(params).then(res => {
          console.log(res);
          this.achievementTransfersList = res.rows;
          this.total = res.total
        })
      } else {
        alert("当前不是管理员");
        //查转让人或接收人是自己的数据
      }
    },

    handleSizeChangeTemporary(val) {
      const userId = localStorage.getItem("userId");
      this.pageSize = val;
      const params = {
        pageSize: val,
        pageNum: this.pageNum,
        userId: userId
      }
      temporarilyList(params).then(res => {
        if (res.code === 200) {
          this.temporaryStorageList = res.rows
          this.total = res.total
        }
      })
    },
    handleCurrentTemporary(val) {
      const userId = localStorage.getItem("userId");
      this.pageNum = val;
      const params = {
        pageSize: this.pageSize,
        pageNum: val,
        userId: userId
      }
      temporarilyList(params).then(res => {
        if (res.code === 200) {
          this.temporaryStorageList = res.rows
          this.total = res.total
        }
      })
    },
  },
};
</script>
<style scoped lang="scss">

::v-deep .deleteTableClass {

  display: flex;
  align-items: center !important;
  color: #ff4d4f !important;
}

.table-action-cell {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
}

.review-log-title {
  margin-bottom: 12px;
  font-size: 15px;
  color: #303133;
  font-weight: 500;
}

::v-deep .table-action-col .cell {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

::v-deep .changeClass {
  padding: 5px 10px !important;
  font-size: 12px;
  border-radius: 3px;
  color: #ffffff !important;
  background-color: #409EFF;
  border-color: #409EFF;
  display: inline-block;
  margin: 0 !important;
}

::v-deep .deleteClass {
  padding: 5px 10px !important;
  font-size: 12px;
  border-radius: 3px;
  color: #ffffff !important;
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  display: inline-block;
  margin: 0 !important;
}

::v-deep .deleteClass:hover,
::v-deep .deleteClass:focus {
  padding: 5px 10px !important;
  color: #ffffff !important;
  background-color: #ff4d4f !important;
  border-color: #ff4d4f !important;
  display: inline-block;
  margin: 0 !important;
}

.clickable {
  color: #0077ff;
  cursor: pointer;
  //text-decoration: underline;
}

::v-deep .el-message {
  height: 80px !important;
}

::v-deep .box-card,
::v-deep .el-card {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

::v-deep .el-card__body {
  width: 100%;
  overflow-x: auto;
  min-width: 0;
  /* Element 默认左右 padding 已对称；不在此再加一层，避免与 .container 叠得过厚 */
  box-sizing: border-box;
}

::v-deep .el-tabs__content {
  overflow-x: auto;
  min-width: 0;
}

::v-deep .el-table {
  min-width: 0;
}

::v-deep .el-table__body-wrapper {
  overflow-x: auto !important;
}

/* 宽度随父级 .me；左右用 padding-inline 保证对称（与 el-card 内边距一致） */
.container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 20px 24px;
  box-sizing: border-box;
  overflow-x: auto;
  min-width: 0;
}

::v-deep .el-table th,
::v-deep .el-table td {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .el-table td.table-action-col,
::v-deep .el-table th.table-action-col {
  white-space: normal;
  overflow: visible;
}

::v-deep .el-table td.audit-review-col,
::v-deep .el-table th.audit-review-col {
  max-width: none;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

::v-deep .audit-review-col .cell {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

.personal-info,
.review-section {
  margin-bottom: 30px;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

h2 {
  color: #333;
  margin-bottom: 10px;
}

h3 {
  color: #666;
  margin-bottom: 8px;
}

.info p,
.review-category p {
  margin: 5px 0;
  text-align: left;
}

.review-category {
  margin-top: 20px;
}

.info p {
  margin-bottom: 16px;
  font-size: 16px;
}

.userInfo {
  margin-bottom: 50px;
}

.itemBox {
  position: relative;
  padding: 20px;
  min-height: 250px;

  .item {
    margin-bottom: 20px;
    font-size: 16px;

    .item_info {
      display: flex;
    }
  }

  .empty {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .noData {
    width: 200px;
  }
}

.el-message-box {
  padding: 20px;
  border-radius: 4px;
}

.el-message-box__header {
  padding: 15px !important;
}

.el-message-box__title {
  font-size: 16px !important;
  color: #333 !important;
}

.el-message-box__content {
  padding: 20px !important;
}

.el-message-box__btns {
  padding: 10px 20px 20px !important;
}

.radio-option {
  font-size: 16px;
}

.el-message--success {
  font-size: 20px;
  margin-bottom: 20%;
}

.el-message-box__header {
  .button {
    display: none !important;
  }
}

.custom-buttonPass {
  padding: 5px 10px;
  font-size: 12px;
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
  border: 1px solid #409EFF;
  border-radius: 3px;
  cursor: pointer;
}

.custom-buttonRefuse {
  padding: 5px 10px;
  font-size: 12px;
  color: #FFF;
  background-color: #ff405d;
  border-color: #ff405d;
  border: 1px solid #ff405d;
  border-radius: 3px;
  cursor: pointer;
  margin-top: 0;
}

.button-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.form-row {
  margin-bottom: 20px;
  margin-top: 20px;
}

.form-input {
  display: block;
  margin-bottom: 8px;
  font-size: 20px;
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-top: 10px;
}

.form-label {
  font-size: 20px;
}

.right-optionValue {
  width: 30%;
  display: flex;
  align-items: center;
  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  label {
    color: #333;
  }
}

.rights-grid {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}

.right-option {
  width: 25%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  label {
    color: #333;
  }
}

.el-card__header {
  display: flex !important;
}

.H2class {
  display: flex;
}

.clearfixRight {
  margin-left: 20px;
  margin-bottom: 20px;
}

.returnClass {
  font-size: 20px;
  margin-bottom: 10px;
  cursor: pointer;
  align-items: center;
  display: flex;
}

.icon {
  width: 40px;
  height: 40px;
}

.returnSpanClass {
  height: 40px;
  align-items: center;
  margin-top: 20px;
  margin-left: 10px;
}

.clearfixRight {
  cursor: pointer;
}

.clearfix {
  cursor: pointer;

  .hover-effect {
    color: black;
    background-color: white;
    padding: 10px;
    text-align: center;
  }

  .hover-effect:hover {
    color: white;
    background-color: blue;
  }
}

.pageList {
  margin-top: 30px;
  /* align-content: center; */
  display: flex;
  justify-content: center;
}

::v-deep .elTab {
  font-size: 20px !important;
}

.search-box {
  font-size: 20px;
}

.transfer-audit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}

.transfer-audit-search {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 0;
}

::v-deep(.el-upload-dragger) {
  width: 450px !important;
}

.userNameClass {
  margin-left: 10px;
}

.companyNameClass {
  margin-left: 30px;
  margin-right: 20px;
}

.hash-cell-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 64px;
  margin: 0 auto;
  display: block;
  text-align: left;
  cursor: default;
}

.hash-empty {
  color: #909399;
}

.unit-review-time-cell {
  display: inline-block;
  max-width: 100%;
  font-size: 12px;
  line-height: 1.35;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
}

/* 审核列表：持有方审核状态 — 长文本换行显示完整单位/人 */
.audit-review-cell {
  text-align: left;
  line-height: 1.45;
  padding: 4px 2px;
  max-width: 100%;
}

.audit-review-unit {
  margin-bottom: 6px;
}

.audit-review-unit-name {
  display: block;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  color: #303133;
  font-size: 13px;
}

.audit-review-meta {
  white-space: normal;
}

/* 评估 + 详情合并列 */
.eval-detail-cell {
  text-align: center;
  line-height: 1.5;
  padding: 2px 4px;
}

.transfer-detail-cell {
  text-align: left;
  line-height: 1.6;
  font-size: 12px;
  color: #606266;
  padding: 4px 0;
}

.transfer-detail-pending {
  color: #e6a23c;
  font-weight: 600;
  margin-bottom: 4px;
}

.eval-detail-eval {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
  font-size: 13px;
}

.eval-detail-links {
  padding-top: 2px;
  font-size: 13px;
}

.reviewer-name-cell {
  display: inline-block;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

</style>

<style lang="scss">
/* el-tooltip 挂载在 body，需单独声明 */
.hash-value-tooltip {
  max-width: min(90vw, 480px);
  word-break: break-all;
  line-height: 1.5;
  white-space: normal;
}

/* 成果转让弹窗（append-to-body，样式需写在此处） */
.transfer-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 48px rgba(15, 35, 95, 0.18);

  .el-dialog__header {
    padding: 0;
    border-bottom: none;
  }

  .el-dialog__headerbtn {
    top: 18px;
    right: 18px;
    font-size: 18px;
    z-index: 2;

    .el-dialog__close {
      color: #fff;

      &:hover {
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }

  .el-dialog__body {
    padding: 0 24px 8px;
    max-height: 68vh;
    overflow-y: auto;
  }

  .el-dialog__footer {
    padding: 14px 24px 20px;
    border-top: 1px solid #eef2f8;
    background: #fafbfd;
  }
}

.transfer-dialog__header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 52px 18px 24px;
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  color: #fff;
}

.transfer-dialog__header-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}

.transfer-dialog__header-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
}

.transfer-dialog__header-sub {
  margin-top: 4px;
  font-size: 13px;
  opacity: 0.92;
  max-width: 520px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.transfer-dialog__body {
  padding-top: 8px;
}

.transfer-section {
  margin-bottom: 18px;
  padding: 16px 16px 4px;
  background: #f8fafc;
  border: 1px solid #e8eef5;
  border-radius: 10px;

  &--upload {
    background: #fff;
  }
}

.transfer-section__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #1f2d3d;
}

.transfer-section__dot {
  width: 4px;
  height: 14px;
  border-radius: 2px;
  background: #1890ff;
  flex-shrink: 0;
}

.transfer-form {
  .el-form-item {
    margin-bottom: 14px;
  }

  .el-form-item__label {
    padding-bottom: 6px;
    line-height: 1.4;
    font-size: 13px;
    color: #606266;
    font-weight: 500;
  }

  .el-input__inner,
  .el-input.is-disabled .el-input__inner {
    border-radius: 6px;
    height: 36px;
    line-height: 36px;
  }

  .el-input-group__prepend {
    background: #f5f7fa;
    border-radius: 6px 0 0 6px;
    color: #909399;
  }
}

.transfer-upload-item {
  margin-bottom: 0 !important;

  .el-form-item__content {
    line-height: normal;
  }
}

.transfer-upload {
  width: 100%;

  .el-upload {
    width: 100%;
  }

  .el-upload-dragger {
    width: 100% !important;
    height: 140px;
    border-radius: 8px;
    border: 1px dashed #c0c4cc;
    background: #fafbfd;
    transition: border-color 0.2s, background 0.2s;

    &:hover {
      border-color: #1890ff;
      background: #f0f7ff;
    }

    .el-icon-upload {
      margin: 28px 0 12px;
      font-size: 42px;
      color: #1890ff;
    }

    .el-upload__text {
      font-size: 14px;
      color: #606266;

      em {
        color: #1890ff;
        font-style: normal;
      }
    }
  }

  .el-upload__tip {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
  }
}

.transfer-preview {
  margin-top: 12px;
  padding: 12px;
  text-align: center;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;

  img {
    max-width: 100%;
    max-height: 160px;
    border-radius: 4px;
    object-fit: contain;
  }
}

.transfer-form-action-col {
  display: flex;
  align-items: flex-end;
  padding-bottom: 14px;
}

.transfer-dialog__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button--primary {
    min-width: 108px;
    border-radius: 6px;
    background: linear-gradient(135deg, #1890ff, #096dd9);
    border: none;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.35);

    &:hover {
      background: linear-gradient(135deg, #40a9ff, #1890ff);
    }
  }

  .el-button--default {
    min-width: 88px;
    border-radius: 6px;
  }
}
</style>

